import { formatPropertyAddress, formatStreetAddress } from '../utils/propertyAddress';
import './MobileMapDisclosure.css';


import {formApprovalCommand} from '../services/assistantFormApproval';
import {activeVoiceForm,sameVoiceForm,requestVoiceFormPatch} from '../services/assistantFormFill';
import { propertyFetch } from '../services/idxPropertyClient';
import PropertyThumbnail from './PropertyThumbnail';

import { loadPropertyMedia, propertyMediaUrls } from '../services/propertyMedia';
import { rememberPropertyPhoto } from '../services/propertyThumbnails';
import { resultsContext, resultsAnnouncement, waitForResults } from '../services/assistantResults';
import MapPlaceLayers from './MapPlaceLayers';
import {mapPlaceCommands,mapPlacesCommand} from '../services/mapPlaces';
import {takeVoiceEntry} from '../services/voiceEntry';
import SellerInquiryReview from './SellerInquiryReview';
import ActiveSearchFilters from './ActiveSearchFilters';
import { filterRemoval, removeSearchFilter } from '../utils/activeSearchFilters';
import { photoCommand } from '../services/assistantPhotos';
import { stagingCommand } from '../services/assistantStaging';
import { assistantIdentity, newNudgeState, nextVoiceNudge } from '../services/assistantConversation';
import { acknowledgeScreenAction, readAssistantScreen, screenCloseCommand, surfaceVisible, waitForScreen } from '../services/assistantScreen';
import { navigationCommand, backCommand, mapPagePoints, zoomMap, scrollPropertyResults } from '../services/assistantNavigation';
import useDiscoveryDialog from '../hooks/useDiscoveryDialog';
import { loadPropertyPage } from "../utils/boundedPropertySearch";


import './BoundedMap.css';
import './MapControls.css';

import { searchSnapshot, assertValidSearch } from "../utils/propertySearchFilters";
// src/components/ActionButtons.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import { addIllustratedBasemap } from '../services/illustratedBasemap';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import { SITE_CONFIG } from "../config";
import { chatSearchSnapshot } from "../utils/chatPropertySearch";
import { decryptPassword } from '../utils/decrypt';
import { hasAdminAccess } from '../utils/authUser';
import { requestPasswordReset, signIn, signUp } from '../services/authService';
import { completeAnalyticsAuthentication, getAnalyticsIdentityForAuth } from "../services/analyticsService";
import { usePropertySave } from './PropertySaveProvider';

import { submitChatLead } from '../services/chatLeadService';
import { useTheme } from '../contexts/ThemeContext';

import PropertyDetailModal from './FleetPropertyDetailModal';
import ChatComposer from './ChatComposer';
import { PreferencesPanel, ComparisonTray, ComparisonPanel } from './AssistantDiscovery';
import useAssistantDiscovery from '../hooks/useAssistantDiscovery';
import { homeKey } from '../services/assistantDiscovery';
import VoiceControls from './VoiceControls';
import useVoiceAssistant from '../hooks/useVoiceAssistant';
import { assistantEnabled, assistantRequest, getAssistantVisitor, selectedPropertyContext, visiblePropertyPage } from '../services/assistantApi';
import PropertySwipeHint from './PropertySwipeHint';
import PropertyRailNavigation from './PropertyRailNavigation';
import HoneypotField, { isHoneypotSubmission, withHoneypotValue } from './HoneypotField';
import './FleetChatAssistant.css';
import './MapDarkMode.css';

const POPULAR_SEARCH_AREAS = Object.keys(SITE_CONFIG.LANDING_PAGE?.CITY_IMAGES || {})
  .slice(0, 6)
  .map((key) => key.toLowerCase().split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '));

const FleetChatAssistant = ({ activeSection, setActiveSection, isGlobeMap, onGlobeMapClose, onGlobeMapResultsChange, directListingKey, directListingReturnTo, directListingReturnState, initialCity, user, isAdmin, setUser, setIsAdmin, hidePrompts, closeDetailRef, isFullPage = false, onBack, voiceEntryId }) => {
const { isDarkMode } = useTheme();

const navigate = useNavigate();

const moreRequestsRef=useRef(new Map());

const chatAbortRef=useRef(null);
  useEffect(()=>()=>{chatGenerationRef.current++;chatAbortRef.current?.abort();moreRequestsRef.current.forEach(controller=>controller.abort());moreRequestsRef.current.clear();},[]);

const { favorites, collections, toggleFavorite, beginAssistantSave, runAssistantSave, saveContext } = usePropertySave();

useEffect(() => { setLikedProperties(favorites); }, [favorites]);

const localFavoritesKey = `propertyFavorites_${SITE_CONFIG.SITE_ID}`;

const [showPrompts, setShowPrompts] = useState(false);

const [inputValue, setInputValue] = useState('');

const [selectedService, setSelectedService] = useState(null);

const [serviceStep, setServiceStep] = useState(0);

const [isThinking, setIsThinking] = useState(false);

const [isPropertySearching, setIsPropertySearching] = useState(false);

const [propertyLocation, setPropertyLocation] = useState('');

const [propertySize, setPropertySize] = useState('');

const [propertyCondition, setPropertyCondition] = useState('');

const [sellingTimeline, setSellingTimeline] = useState('');

const [showThankYouMessage, setShowThankYouMessage] = useState(false);

const [zipCode, setZipCode] = useState('');

const [name, setName] = useState('');

const [phoneNumber, setPhoneNumber] = useState('');

const [email, setEmail] = useState('');

const [messages, setMessages] = useState([]);

const messagesRef = useRef(messages);

messagesRef.current = messages;

const propertyModalRef = useRef(null);

const sellerReviewRef = useRef(null);

const [sellerUi, setSellerUi] = useState({});

const onSellerState = useCallback(next=>setSellerUi(previous=>JSON.stringify(previous)===JSON.stringify(next)?previous:next),[]);

const detailGenerationRef = useRef(0);

const [detailUi, setDetailUi] = useState({});

const detailUiRef = useRef(detailUi);

detailUiRef.current = detailUi;

const onDetailUi = useCallback(update => setDetailUi(previous => {
    const next = { ...previous, ...update };
    return JSON.stringify(next) === JSON.stringify(previous) ? previous : next;
  }), []);

const messagesContainerRef = useRef(null);

const chatSearchContextRef = useRef(null);

const [pendingSearchFilters, setPendingSearchFilters] = useState(null);

const chatGenerationRef = useRef(0);

const nudgeStateRef = useRef(newNudgeState());

const chatRequestInFlightRef = useRef(false);

const chatPropertyRequestRef = useRef(0);

const chatSiteId = SITE_CONFIG.SITE_ID;

useEffect(() => {
    chatSearchContextRef.current = null;
    setPendingSearchFilters(null);
    nudgeStateRef.current = newNudgeState();
    chatRequestInFlightRef.current = false;
    setMessages([]);
    setIsThinking(false);
    setIsPropertySearching(false);
    return () => {
      // A late reply must not repopulate a closed/reset/site-switched conversation.
      chatGenerationRef.current += 1;
      chatPropertyRequestRef.current += 1;
    };
  }, [chatSiteId]);

const [showRegistration, setShowRegistration] = useState(false);

const [regEmail, setRegEmail] = useState('');

const [regName, setRegName] = useState('');

const [regPassword, setRegPassword] = useState('');

const [regPhoneNumber, setRegPhoneNumber] = useState('');

const [regFullName, setRegFullName] = useState('');

const [showLogin, setShowLogin] = useState(false);

const [loginUsername, setLoginUsername] = useState('');

const [loginPassword, setLoginPassword] = useState('');

const [showForgotPassword, setShowForgotPassword] = useState(false);

const [resetEmail, setResetEmail] = useState('');

const [expandedMap, setExpandedMap] = useState(null);

const [expandedMapZoom, setExpandedMapZoom] = useState(null);

const expandedMapDialogRef = useDiscoveryDialog(Boolean(expandedMap), () => setExpandedMap(null));

const mapRef = useRef(null);

const leafletMapRef = useRef(null);

const [expandedMapInstance,setExpandedMapInstance]=useState(null),[globeMapInstance,setGlobeMapInstance]=useState(null);

const mapPlacesRef=useRef(null),mapPlacesStateRef=useRef({});

const mapPlacesState=useCallback(value=>{mapPlacesStateRef.current=value;},[]);

const [globeMap, setGlobeMap] = useState(() => {
    const saved = sessionStorage.getItem('globeMapData');
    if (saved && isGlobeMap && new URLSearchParams(window.location.search).get('saved')==='true') {
      sessionStorage.removeItem('globeMapData');
      try { return JSON.parse(saved); } catch { return null; }
    }
    return null;
  });

const globeLeafletRef = useRef(null);

const [maxPrice, setMaxPrice] = useState('');

const [propertyDetail, setPropertyDetail] = useState(null);

const selectedPropertyRef = useRef(propertyDetail);

selectedPropertyRef.current = propertyDetail;

const [propertyImages, setPropertyImages] = useState({});

const propertyImagesRef = useRef(propertyImages);

const [propertyMedia,setPropertyMedia] = useState([]);

const [discoveryConfig,setDiscoveryConfig] = useState({});

useEffect(()=>{if(assistantEnabled)assistantRequest('/discovery/config',{}).then(setDiscoveryConfig).catch(()=>{});},[]);

const [propertyDetailImages, setPropertyDetailImages] = useState([]);

const [imagesLoading, setImagesLoading] = useState(false);

const [enlargedImage, setEnlargedImage] = useState(null);

const [likedProperties, setLikedProperties] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(localFavoritesKey) || '[]');
      return new Set(Array.isArray(saved) ? saved : []);
    } catch (error) {
      return new Set();
    }
  });

const [mapView, setMapView] = useState(true);

const [activeMapTool, setActiveMapTool] = useState(null);

const setPlacesOpen = useCallback(open => setActiveMapTool(open ? 'places' : null), []);

useEffect(() => { setActiveMapTool(null); }, [propertyDetail, expandedMap, mapView]);

const itemsPerPage = 6;

const [openChat, setOpenChat] = useState(false);

const [pendingSellerParams, setPendingSellerParams] = useState(null);

const [pendingBuyerParams, setPendingBuyerParams] = useState(null);

const [chatLeadSubmitted, setChatLeadSubmitted] = useState(false);

const lastSubmittedLeadRef = useRef(null);

const [leadName, setLeadName] = useState('');

const [leadPhone, setLeadPhone] = useState('');

const [leadEmail, setLeadEmail] = useState('');

const [showAlertPill, setShowAlertPill] = useState(false);

const [alertPillState, setAlertPillState] = useState('prompt');

const [senderEmail, setSenderEmail] = useState('');

const [senderPassword, setSenderPassword] = useState('');

const [mobileWorkspaceView, setMobileWorkspaceView] = useState('chat');

const assistantWorkspaceRef = useRef(null);

const assistantResultsPanelRef = useRef(null);

const assistantPropertyRailRef = useRef(null);

const pendingPropertyRevealRef = useRef(null);

const lastMobilePropertyResultRef = useRef('');

const scrollMobileWorkspaceTo = (view, behavior = 'smooth') => {
    setMobileWorkspaceView(view);
    if (view === 'chat') pendingPropertyRevealRef.current = null;
    const workspace = assistantWorkspaceRef.current;
    if (!workspace) return;
    workspace.scrollTo({
      left: view === 'results' ? Math.max(0, workspace.scrollWidth - workspace.clientWidth) : 0,
      behavior
    });
  };

const handleMobileWorkspaceScroll = () => {
    if (!window.matchMedia('(max-width: 820px)').matches) return;
    const workspace = assistantWorkspaceRef.current;
    if (!workspace) return;
    const nextView = workspace.scrollLeft > workspace.clientWidth / 2 ? 'results' : 'chat';
    setMobileWorkspaceView((currentView) => currentView === nextView ? currentView : nextView);
  };

useEffect(() => { propertyImagesRef.current = propertyImages; }, [propertyImages]);

useEffect(() => {
    if (closeDetailRef) {
      closeDetailRef.current = () => {
        if (enlargedImage) { setEnlargedImage(null); return true; }
        if (propertyDetail) { setPropertyDetail(null); return true; }
        return false;
      };
    }
  }, [closeDetailRef, propertyDetail, enlargedImage]);

useEffect(() => {
    let cancelled = false;

    try {
      const cached = JSON.parse(localStorage.getItem(`featureFlags_${SITE_CONFIG.SITE_ID}`) || 'null');
      if (cached && typeof cached.openChat === 'boolean') setOpenChat(cached.openChat);
    } catch (e) { /* ignore */ }

    const fetchFeatureFlags = async (attempt = 0) => {
      const retry = () => {
        if (attempt < 3 && !cancelled) {
          setTimeout(() => fetchFeatureFlags(attempt + 1), 1500 * (attempt + 1));
          return true;
        }
        return false;
      };
      try {
        const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/feature-flag?siteId=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'X-API-Key': 'treas-api-key-2025' }
        });
        if ((response.status === 429 || response.status >= 500) && retry()) return;
        if (response.ok) {
          const data = await response.json();
          if (cancelled) return;
          setOpenChat(data.openChat || false);
          if (data.senderEmail) setSenderEmail(data.senderEmail);
          if (data.senderEmailPassword) {
            decryptPassword(data.senderEmailPassword).then(pw => { if (pw) setSenderPassword(pw); });
          }
          try {
            localStorage.setItem(`featureFlags_${SITE_CONFIG.SITE_ID}`, JSON.stringify({ openChat: !!data.openChat }));
          } catch (e) { /* ignore */ }
        }
      } catch (error) {
        if (retry()) return;
        console.error('Error fetching feature flags:', error);
      }
    };
    fetchFeatureFlags();
    return () => { cancelled = true; };
  }, []);

useEffect(() => {
    const saved = localStorage.getItem('leadInfo');
    if (saved) {
      const { name: n, email: e, phone: p } = JSON.parse(saved);
      if (n) setName(n);
      if (e) setEmail(e);
      if (p) setPhoneNumber(p);
      if (n && e && p) setChatLeadSubmitted(true);
    }
  }, []);

const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

useEffect(() => {
    scrollToBottom();
  }, [messages]);

useEffect(() => {
    if (showRegistration || showLogin || selectedService || isThinking || isPropertySearching) {
      setTimeout(scrollToBottom, 200);
    }
  }, [showRegistration, showLogin, selectedService, serviceStep, isThinking, isPropertySearching]);

useEffect(() => {
    if (!expandedMap || !mapRef.current) {setExpandedMapZoom(null); return undefined;}
    const map = L.map(mapRef.current, {minZoom:1, maxZoom:19}).setView([expandedMap.lat, expandedMap.lon], 15);
    addIllustratedBasemap(map);
    const points = expandedMap.points || [{lat:expandedMap.lat, lon:expandedMap.lon}];
    points.forEach(point => {
      const icon = L.divIcon({html:point.number ? `<span>${point.number}</span>` : '🏠',
        className:point.number ? 'assistant-numbered-map-marker' : 'house-marker', iconSize:[34,34], iconAnchor:[17,17]});
      L.marker([point.lat,point.lon], {icon}).addTo(map);
    });
    if (points.length > 1) map.fitBounds(points.map(p=>[p.lat,p.lon]), {padding:[35,35],maxZoom:15,animate:false});
    leafletMapRef.current = map;setExpandedMapInstance(map);
    setExpandedMapZoom(map.getZoom());
    map.on('zoomend', () => setExpandedMapZoom(map.getZoom()));
    const timer = setTimeout(()=>map.invalidateSize(),50);
    return () => {clearTimeout(timer);map.remove();leafletMapRef.current=null;setExpandedMapInstance(null);};
  }, [expandedMap]);

const commonPrompts = [
    { display: zipCode ? `Homes in ${zipCode}` : "Find a home", value: zipCode ? `Show me properties in ${zipCode}` : "Help me find a home" },
    { display: "Create an alert", value: "Help me create a property alert" },
    { display: "Sell my home", value: "I am thinking about selling my home" },
    { display: `Contact ${SITE_CONFIG.AGENT.NAME}`, value: `Contact ${SITE_CONFIG.AGENT.NAME}` }
  ];

const handlePromptSelect = (promptValue) => {
    setShowPrompts(false);
    if (isFullPage) {
      if (chatRequestInFlightRef.current || isThinking || isPropertySearching) return;
      setInputValue('');
      return processAssistantMessage(promptValue);
    }
    setInputValue(promptValue);
  };

const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await submitChatLead(withHoneypotValue({
        postalCode: zipCode,
        name,
        phoneNumber,
        serviceReq: selectedService,
        email,
        siteId: SITE_CONFIG.SITE_ID
      }, e.currentTarget), { rememberContact: true });

      if (response.ok) {
        console.log('Form submitted successfully');
        // Clear form but keep customer info for later use
        // setZipCode(''); // Keep zip code for property search
        // Keep name, phone, email for selling details form
        // setName('');
        // setPhoneNumber('');
        // setEmail('');
        // Show thank you message
        setShowThankYouMessage(true);
        setTimeout(scrollToBottom, 200);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

const discovery = useAssistantDiscovery({favorites:likedProperties,messagesRef,setMessages,closeProperty:()=>{detailGenerationRef.current++;setExpandedMap(null);setPropertyDetail(null);},loadHome:async (home,details)=>{
    const key=homeKey(home);
    if(key.startsWith('PRIVATE_')) {
      const response=await fetch(`https://tophamtechbe.com/api/treas/private/v1/listing/${encodeURIComponent(key.slice(8))}?site_id=${encodeURIComponent(SITE_CONFIG.SITE_ID)}`,{headers:{'X-API-Key':'treas-api-key-2025'}});
      if(!response.ok)return null;const data=await response.json();const row=data.listing || data;
      return {...row,listing_key:key,isPrivate:true,current_price:row.price_sale || row.price_lease_monthly,bedrooms_total:row.beds,bathrooms_total:row.baths,address:[row.address_line_1,row.city,row.state_province].filter(Boolean).join(', ')};
    }
    const response=await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${encodeURIComponent(key)}`);
    if(!response.ok)return null;const row=(await response.json()).properties?.[0];if(!row || String(row.listing_key)!==key)return null;
    if(!details)return row;
    const detail=await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-data/${encodeURIComponent(row.id)}`);
    if(!detail.ok)return null;const full=(await detail.json()).properties?.[0];return full && String(full.listing_key)===key?full:null;
  }});

const discoveryRevisionRef=useRef({signature:'',version:0});

const revisionFor=value=>{const signature=JSON.stringify(value);if(discoveryRevisionRef.current.signature!==signature)discoveryRevisionRef.current={signature,version:discoveryRevisionRef.current.version+1};return String(discoveryRevisionRef.current.version);};

const getAssistantContext = () => {
    const latest = [...messagesRef.current].reverse().find(m => m.content === 'properties');
    const page = visiblePropertyPage(latest);
    const selectedKey = selectedPropertyRef.current?.listing_key;
    const index = page.findIndex(p => p.listing_key === selectedKey);
    const detail = selectedPropertyRef.current ? detailUiRef.current : {};
    const browsingMap=isGlobeMap&&globeMap&&mapView&&!selectedPropertyRef.current;
    const mapKind = expandedMap ? 'results' : detail.location_map_open ? 'property' : detail.nearby_open ? 'nearby' : browsingMap ? 'results' : null;
    const places=expandedMap||browsingMap?{...mapPlacesStateRef.current,...mapPlacesRef.current?.context()}:detail;
    const mapZoom = expandedMap ? expandedMapZoom : detail.location_map_open ? detail.location_map_zoom : detail.nearby_map_zoom;
    return {
      ...detail,
      ...saveContext(),
      ...places,
      ...(sellerReviewRef.current?.context() || sellerUi),
      map_open: Boolean(mapKind), map_kind: mapKind,
      map_ready: expandedMap ? expandedMapZoom != null : detail.location_map_open ? detail.location_map_ready : browsingMap ? !!globeMapInstance : detail.nearby_map_ready,
      map_zoom: mapKind ? mapZoom : null,
      ...discovery.context(),
      current_date: discoveryConfig.current_date, timezone: discoveryConfig.timezone,
      results_mode: latest?.isFavorites ? 'favorites' : 'search',
      view: saveContext().save_open ? 'save' : sellerReviewRef.current?.context().seller_review_open ? 'seller_review' : mapKind ? 'map' : selectedPropertyRef.current ? (detail.gallery_open ? 'photos' : 'property') : 'results',
      revision: revisionFor([saveContext(),selectedKey ? favorites.has(String(selectedKey)) : false,places.map_area_revision,places.map_place_layers,places.selected_map_place,sellerReviewRef.current?.context() || sellerUi, mapKind, mapZoom, Boolean(detail.email_open), latest?.searchId ?? null, latest?.currentPage || 0, page.length, Boolean(latest?.hasMore), Boolean(latest?.loadingMore), latest?.pageError, selectedKey || null, Boolean(detail.gallery_open), detail.photo_number || 0, detail.photo_ref, Boolean(detail.photo_staged), Boolean(detail.staging_open), Boolean(detail.email_ready), detail.room_filter, Boolean(detail.nearby_open), Boolean(detail.showing_open), Boolean(detail.showing_ready), detail.showing_status, detail.showing_missing_fields, detail.showing_draft, detail.nearby_summary, discovery.context()]),
      ...resultsContext(latest),
      selected_saved: selectedKey ? favorites.has(String(selectedKey)) : false,
      selected_number: index < 0 ? null : index + 1,
      selected_property: selectedPropertyContext(selectedPropertyRef.current)
    };
  };

const currentResults = () => [...messagesRef.current].reverse().find(m => m.content === 'properties');

const confirmResults = async (searchId, page, isCurrent) => {
    const rendered = await waitForResults({getMessage:currentResults, searchId, page, isCurrent});
    if (isCurrent && !isCurrent()) return 'The search was superseded by your latest request.';
    return rendered ? resultsAnnouncement(currentResults()) : 'The search returned, but I could not confirm that the new results finished displaying. Please try again.';
  };

const chatHistory = (excludeIds = new Set()) => messagesRef.current
    .filter(m => typeof m.content === 'string' && !['properties', 'seller_lead_capture', 'buyer_lead_capture', 'agent_contact_capture'].includes(m.content) && !excludeIds.has(m.id))
    .map(m => ({ role: m.type === 'user' ? 'user' : 'assistant', content: m.content }));

const processAssistantMessage = async (messageToSend, options = {}) => {
    if (!messageToSend.trim()) return '';
    if (chatRequestInFlightRef.current || isPropertySearching) return 'The previous request is still running. Please repeat that when it finishes.';
    const history = chatHistory(options.excludeIds);
    if (!options.voiceSessionId) setMessages(prev => [...prev, { type: 'user', content: messageToSend }]);
    if (/\b(sign in|signin|login|log in)\b/i.test(messageToSend)) {
      setShowLogin(true);
      const reply = 'Please enter your sign-in details in the form.';
      if (!options.voiceSessionId) setMessages(prev => [...prev, { type: 'bot', content: reply }]);
      return reply;
    }
    const removal = filterRemoval(messageToSend, chatSearchContextRef.current?.params);
    if (removal && chatSearchContextRef.current?.siteId === chatSiteId) {
      if (options.isCurrent && !options.isCurrent()) return 'The request was superseded.';
      const generation=chatGenerationRef.current;
      chatRequestInFlightRef.current=true;
      try {
        const reply = await fetchProperties(removeSearchFilter(chatSearchContextRef.current.params, removal.keys), options);
        if (generation !== chatGenerationRef.current || (options.isCurrent && !options.isCurrent())) return 'The request was superseded.';
        if (!options.voiceSessionId && reply) {
          setMessages(prev => [...prev, {type:'bot',content:reply}]);
          if (voice.active) voice.append('The customer typed: ' + messageToSend + '. ' + reply);
        }
        return reply;
      } finally {if(generation===chatGenerationRef.current)chatRequestInFlightRef.current=false;}
    }
    const approvalUi={...getAssistantContext(), ...readAssistantScreen(getAssistantContext())};
    const approval = assistantEnabled && formApprovalCommand(messageToSend, approvalUi);
    if (approval && options.formAtSpeech) {
      const currentForm=activeVoiceForm(approvalUi);
      if (!sameVoiceForm(currentForm,options.formAtSpeech) || JSON.stringify(currentForm.edits)!==JSON.stringify(options.formAtSpeech.edits)) return 'The form changed after your approval. Check the current details before sending.';
    }
    const localNavigation = assistantEnabled && (approval || stagingCommand(messageToSend, {...getAssistantContext(), ...readAssistantScreen(getAssistantContext())}) || mapPlacesCommand(messageToSend, getAssistantContext()) || photoCommand(messageToSend, getAssistantContext()) || navigationCommand(messageToSend, getAssistantContext()));
    if (localNavigation) {
      if (options.isCurrent && !options.isCurrent()) return 'The request was superseded by what you said next.';
      const reply = await executeAssistantUi({...localNavigation, revision:getAssistantContext().revision}, options);
      if (!options.voiceSessionId) {
        setMessages(prev => [...prev, {type:'bot',content:reply}]);
        if (voice.active) voice.append('The customer typed: ' + messageToSend + '. ' + reply);
      }
      return reply;
    }
    if (assistantEnabled && getAssistantContext().photo_tour) await propertyModalRef.current?.run({command:'stop_photo_tour'});
    chatRequestInFlightRef.current = true;
    const generation = chatGenerationRef.current;
    const ui = getAssistantContext();
    ui.screen = readAssistantScreen(ui).screen;
    setIsThinking(true);
    try {
      let auth = {};
      // Voice setup errors never prevent the existing text endpoint from working.
      if (assistantEnabled) {
        try { auth = { Authorization: `Bearer ${(await getAssistantVisitor()).token}` }; }
        catch (e) { if (options.voiceSessionId) throw e; }
      }
      if (!options.voiceSessionId && voice.active) voice.append('The customer typed: ' + messageToSend, null, true);
      const response = await fetch('https://tophamtechbe.com/llm/v1/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...auth },
        body: JSON.stringify({
          message: messageToSend, site_id: SITE_CONFIG.SITE_ID,
          capabilities: ['conversational_contact', 'robust_search_v1', 'home_types_v1', ...(assistantEnabled ? ['assistant_ui_v1', 'assistant_discovery_v1', 'assistant_navigation_v1', 'assistant_conversation_v1', 'assistant_photos_v1', 'assistant_map_places_v1', 'assistant_handsfree_v1', ...((options.voiceSessionId || ['review','sending','sent','uncertain'].includes(sellerReviewRef.current?.context().seller_review_status)) ? ['assistant_seller_review_v1'] : [])] : [])],
          known_lead: !!(user || chatLeadSubmitted),
          ...(chatSearchContextRef.current?.siteId === chatSiteId ? { search_context: chatSearchContextRef.current.params } : {}),
          ...(assistantEnabled ? { ui_context: ui } : {}),
          ...(options.voiceSessionId ? { voice_session_id: options.voiceSessionId } : {}),
          conversation_history: history
        })
      });
      let data;
      try { data = await response.json(); } catch { throw new Error('The assistant could not read that response. Please try again.'); }
      if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'The assistant could not connect. Please try again.');
      if (generation !== chatGenerationRef.current) return 'The conversation has changed.';
      if (options.isCurrent && !options.isCurrent()) return 'The request was superseded by what you said next. Please confirm your latest request.';
      if (data.photo_context && (data.photo_context.revision !== getAssistantContext().revision || data.photo_context.photo_ref !== getAssistantContext().photo_ref)) {
        const changed='The photo changed while I was looking. Ask again about the photo now open.';
        if(!options.voiceSessionId)setMessages(prev=>[...prev,{type:'bot',content:changed}]);
        return changed;
      }
      let reply = data.response || '';
      if (data.photo_context && reply) propertyModalRef.current?.showPhotoAnswer(reply, data.photo_context.photo_ref);
      if (options.voiceSessionId && data.sources?.length) setMessages(prev => [...prev, { type: 'bot', content: 'Sources for nearby places', sources: data.sources }]);
      if (data.action) {
        const result = data.action === 'assistant_ui'
          ? await executeAssistantUi(data.params, options)
          : await handleAction(data.action, data.params, {isCurrent:()=>generation === chatGenerationRef.current && (!options.isCurrent || options.isCurrent()),reviewSeller:Boolean(options.voiceSessionId || ['review','sending','sent','uncertain'].includes(sellerReviewRef.current?.context().seller_review_status))});
        if (typeof result === 'string') reply = result;
        else if (options.voiceSessionId && !['collecting_buyer_info','collecting_seller_info'].includes(data.action)) reply = 'I do not have a confirmed outcome for that action yet. I cannot confirm that it was submitted or that a review form is open.';
      }
      if (reply && discovery.context().comparison_open) discovery.setAnswer(reply);
      if (reply && !options.voiceSessionId) {
        setMessages(prev => [...prev, { type: 'bot', content: reply, sources: data.sources }]);
        if (voice.active) voice.append(reply);
      }
      return reply;
    } catch (e) {
      const reply = e.message || 'The assistant could not connect. Please try again.';
      if (generation === chatGenerationRef.current && !options.voiceSessionId) setMessages(prev => [...prev, { type: 'bot', content: reply }]);
      return reply;
    } finally {
      if (generation === chatGenerationRef.current) { chatRequestInFlightRef.current = false; setIsThinking(false); }
    }
  };

const getVoiceForm = () => {
    const ui=currentContextRef.current();
    return activeVoiceForm({...ui,screen:readAssistantScreen(ui).screen});
  };

const fillVoiceForm = async (text, options) => {
    if (!options.isCurrent()) return 'The form changed. Nothing was filled in.';
    const ui=currentContextRef.current();
    const renderedUi={...ui,...readAssistantScreen(ui)};
    const navigation=photoCommand(text,renderedUi) || navigationCommand(text,renderedUi);
    // A queued navigation request belongs to the screen left by the preceding
    // command, not to the form that happened to be open when speech started.
    // Submission and field updates still require the original form identity.
    if (navigation && !['confirm_save','save_property'].includes(navigation.command)) return null;
    const latest=getVoiceForm();
    if (!sameVoiceForm(latest,options.form) || !options.isCurrent()) return 'The form changed. Nothing was filled in.';
    try {
      // Let the ordered voice action consume this approval once, without another model round trip.
      if (formApprovalCommand(text,{...ui,screen:latest.kind})) return null;
      const patch=await requestVoiceFormPatch({text,form:latest,ui:{...ui,screen:latest.kind},voiceSessionId:options.voiceSessionId});
      if (!options.isCurrent() || !sameVoiceForm(getVoiceForm(),options.form)) return 'The form changed. Nothing was filled in.';
      if (patch.intent==='other') return null;
      if (patch.intent==='clarify') return patch.clarification || 'Please repeat that detail or type it in the form.';
      const params={...patch.fields,form_guard:options.form};
      let result;
      if(latest.kind==='save') result=await runAssistantSave({...params,command:'update_save_contact'});
      else if(latest.kind==='showing') result=await propertyModalRef.current?.run({...params,command:'update_showing'});
      else result=await sellerReviewRef.current?.run({...params,command:'update_seller_review'});
      // Allow the draft inputs and bounded UI snapshot to commit before readback.
      await waitForScreen(()=>true,options.isCurrent);
      if(!options.isCurrent() || !sameVoiceForm(getVoiceForm(),options.form)) return 'The form changed. Use the details currently displayed.';
      return result || 'Please check the details currently displayed in the form.';
    } catch (error) {
      return error.message || 'I could not fill in that detail. Please repeat it or type it in the form.';
    }
  };

const voice = useVoiceAssistant({
    conversationKey: `${chatSiteId}:${chatGenerationRef.current}`,
    getNudge: (message, result) => nextVoiceNudge(nudgeStateRef.current, {
      message, result, agentName:SITE_CONFIG.AGENT.NAME || 'the agent',
      context:{...getAssistantContext(),
        selected_saved:likedProperties.has(selectedPropertyRef.current?.listing_key),
        workflow_open:showRegistration || showLogin || showForgotPassword || Boolean(pendingBuyerParams || pendingSellerParams) || messagesRef.current.some(m=>!m.submitted && ['seller_lead_capture','buyer_lead_capture','agent_contact_capture'].includes(m.content)) || Boolean(selectedService && !showThankYouMessage),
        alerts_started:nudgeStateRef.current.used.includes('alerts') || (showAlertPill && alertPillState!=='prompt'),
        selling_details_started:selectedService==='selling',
        contact_started:Boolean(user || chatLeadSubmitted)}
    }),
    getHistory: () => chatHistory(),
    getContext: () => { const { selected_property, comparison_properties, ...ui } = getAssistantContext(); return {...ui,screen:readAssistantScreen(ui).screen}; },
    onTask: processAssistantMessage,
    getForm: getVoiceForm,
    onFormTranscript: fillVoiceForm,
    onTranscript: row => setMessages(prev => {
      const found = prev.findIndex(m => m.id === row.id);
      return found < 0 ? [...prev, row] : prev.map((m, i) => i === found ? row : m);
    })
  });

const startVoice = voice.start;

useEffect(() => {
    if (!assistantEnabled || !isFullPage || !voiceEntryId) return undefined;
    // Scheduling allows StrictMode's mount rehearsal to cancel before consuming
    // the one-use entry. Back/refresh never grants new microphone permission.
    const timer = setTimeout(() => {
      const entry = takeVoiceEntry(voiceEntryId);
      if (entry) startVoice(entry);
    }, 0);
    return () => clearTimeout(timer);
  }, [isFullPage, voiceEntryId, startVoice]);

const appendVoiceResult = voice.append;

const uiForVoice = getAssistantContext();

const uiRevision = uiForVoice.revision;

const uiContextRef = useRef(uiForVoice);

uiContextRef.current = uiForVoice;

useEffect(() => {
    if (!voice.active) return;
    const { selected_property, comparison_properties, ...currentUi } = uiContextRef.current;
    appendVoiceResult(JSON.stringify({...currentUi,screen:readAssistantScreen(currentUi).screen}), null, true);
  }, [voice.active, uiRevision, appendVoiceResult]);

const assistantResult = useCallback(text => {
    if (!text) return;
    setMessages(prev => [...prev, { type: 'bot', content: text }]);
    appendVoiceResult(text);
  }, [appendVoiceResult]);

const handleSendMessage = async e => {
    e.preventDefault();
    if (!inputValue.trim() || chatRequestInFlightRef.current || isPropertySearching) return;
    const text = inputValue; setInputValue('');
    return processAssistantMessage(text);
  };

const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage(e);
    }
  };

const submitSellerInquiry = async (params, userEmail, userName, userPhone) => {
    try {
      const p = params || {};
      const queryParams = new URLSearchParams({
        location: p.location || '',
        propertyDetails: p.property_details || '',
        email: userEmail,
        phoneNumber: userPhone,
        name: userName,
        siteId: SITE_CONFIG.SITE_ID
      });

      if (p.address) {
        queryParams.append('address', p.address);
      }

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-inquiry?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        return {ok:true};
      } else {
        return {ok:false};
      }
    } catch (error) {
      return {ok:false};
    }
  };

const storeConversation = async (params) => {
    try {
      const queryParams = new URLSearchParams({
        reason: params.reason || 'inquiry',
        contactInfo: email || params.contactInfo || '',
        conversationSummary: params.conversationSummary || '',
        phone: phoneNumber || params.phone || '',
        name: name || params.name || '',
        siteId: SITE_CONFIG.SITE_ID
      });

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/store-convo?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Conversation stored successfully');
      } else {
        console.error('Failed to store conversation');
      }
    } catch (error) {
      console.error('Error storing conversation:', error);
    }
  };

const sendAgentSMS = async (customerName, customerPhone) => {
    try {
      const formData = new FormData();
      formData.append('to', SITE_CONFIG.AGENT.PHONE);
      formData.append('body', `Agent Winds Message: ${customerName} has requested you contact them at ${customerPhone}`);

      const response = await fetch('https://tophamtechbe.com/api/treas/comm/send-sms', {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        },
        body: formData
      });

      if (response.ok) {
        console.log('SMS sent to agent successfully');
      } else {
        console.error('Failed to send SMS to agent');
      }
    } catch (error) {
      console.error('Error sending SMS to agent:', error);
    }
  };

const handleGetCRM = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your progress status.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/crm?email=${encodeURIComponent(userEmail)}&siteId=${SITE_CONFIG.SITE_ID}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const data = await response.json();
        const stages = ['lead', 'discover', 'onboard', 'research', 'offer', 'inspection', 'closing', 'complete'];
        const stageLabels = {
          lead: 'Initial Lead',
          discover: 'Discovery Call',
          onboard: 'Client Onboard',
          research: 'Market Research',
          offer: 'Make Offer',
          inspection: 'Home Inspection',
          closing: 'Closing Process',
          complete: 'Deal Complete'
        };

        let currentStage = null;
        let currentNote = null;

        // Find the furthest non-null stage
        for (let i = stages.length - 1; i >= 0; i--) {
          const stage = stages[i];
          if (data[stage] !== null) {
            currentStage = stage;
            currentNote = data[`${stage}Note`];
            break;
          }
        }

        let statusMessage;
        if (currentStage) {
          const stageLabel = stageLabels[currentStage];
          const status = data[currentStage];
          statusMessage = `🏠 **Current Status: ${stageLabel}**\n\n📊 Status: ${status}`;
          if (currentNote) {
            statusMessage += `\n📝 Note: ${currentNote}`;
          }
        } else {
          statusMessage = '🏠 **Your Progress**\n\nNo progress recorded yet. Contact us to get started!';
        }

        const botMessage = { type: 'bot', content: statusMessage };
        setMessages(prev => [...prev, botMessage]);
      } else {
        const botMessage = { type: 'bot', content: 'No progress information found. Contact us to get started with your real estate journey!' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Error fetching CRM data:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your progress at this time. Please try again later.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

const fetchLikedProperties = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your liked properties.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/interested-buy?email=${encodeURIComponent(userEmail)}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const likedData = await response.json();
        if (likedData.length === 0) {
          const botMessage = { type: 'bot', content: 'You haven\'t liked any properties yet.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        const listingKeys = likedData.map(item => item.listingKey);
        const propertiesPromises = listingKeys.map(key =>
          propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${key}`).then(res => res.json())
        );

        const propertiesResults = await Promise.all(propertiesPromises);
        const likedProperties = propertiesResults
          .map(result => result.properties?.[0])
          .filter(prop => prop);

        if (likedProperties.length > 0) {
          const propertiesMessage = {
            type: 'bot',
            content: 'properties',
            properties: likedProperties,
            currentPage: 0
          };
          setMessages(prev => [...prev, propertiesMessage]);
        }
      }
    } catch (error) {
      console.error('Error fetching liked properties:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your liked properties at this time.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

const currentContextRef = useRef(null);

currentContextRef.current = getAssistantContext;

const actionVersionRef = useRef(0);

const executeAssistantUi = async (params = {}, options = {}) => {
    const getContext = () => currentContextRef.current();
    if (params.revision !== getContext().revision) return 'The page changed while I was processing that. Please repeat the command for the current screen.';
    const version = ++actionVersionRef.current;
    const generation = chatGenerationRef.current;
    const isCurrent = () => version === actionVersionRef.current && generation === chatGenerationRef.current && (!options.isCurrent || options.isCurrent());
    const screen = readAssistantScreen(getContext());
    const command = params.command === 'go_back' ? screenCloseCommand(screen.screen) || (screen.screen === 'unknown' ? backCommand(getContext()) : null) : params.command;
    if (!command) return 'There is no open panel to close. You can keep browsing or ask for homes.';
    const result = await runAssistantUi({...params,command}, {...options,isCurrent});
    return acknowledgeScreenAction({command,result,getContext,isCurrent});
  };

const runAssistantUi = async (params = {}, options = {}) => {
    if (params.revision !== getAssistantContext().revision) return 'The page changed while I was processing that. Please repeat the command for the current screen.';
    if (['update_save_contact','confirm_save','cancel_save','get_save_status'].includes(params.command)) return runAssistantSave(params);
    if (saveContext().save_open) {
      if (['return_to_results','return_to_property','close_property'].includes(params.command)) {
        if (saveContext().save_busy) return 'The property save is still running. Please wait.';
        await runAssistantSave({command:'cancel_save'});
      } else return 'Finish the save form or say cancel save before browsing another home.';
    }
    if (['scroll_results_up','scroll_results_down','show_tile'].includes(params.command)) {
      const ui = getAssistantContext();
      if (ui.view !== 'results' || ui.showing_open || ui.email_open || ui.comparison_open || ui.preferences_open) return 'Return to the property results first, then ask me to scroll.';
      const mobile = window.matchMedia('(max-width: 820px)').matches;
      if (mobile) scrollMobileWorkspaceTo('results');
      return scrollPropertyResults({panel:assistantResultsPanelRef.current,rail:assistantPropertyRailRef.current,mobile,...params});
    }
    if(mapPlaceCommands.includes(params.command) || (params.command==='find_nearby'&&getAssistantContext().map_open)) {
      const command=params.command==='find_nearby'?{...params,command:'show_map_places'}:params;
      const isCurrent=()=>generation===chatGenerationRef.current && (!options.isCurrent || options.isCurrent());
      const generation=chatGenerationRef.current;
      if(expandedMap||(isGlobeMap&&globeMap&&mapView&&!selectedPropertyRef.current))return mapPlacesRef.current?.run(command,isCurrent) || 'The map is loading. Please try again.';
      return propertyModalRef.current?.run({...command,isCurrent}) || 'Open a map first, then ask for nearby places.';
    }
    if (['open_seller_review','update_seller_review','submit_seller_review','cancel_seller_review'].includes(params.command)) return sellerReviewRef.current?.run(params) || 'The selling review is not ready yet.';
    if (params.command === 'go_back' && sellerReviewRef.current?.context().seller_review_open) return sellerReviewRef.current.run({command:'cancel_seller_review'});
    if (['return_to_results','return_to_property'].includes(params.command) && sellerReviewRef.current?.context().seller_review_open) sellerReviewRef.current.run({command:'cancel_seller_review'});
    const latestIndex = messagesRef.current.reduce((found, m, i) => m.content === 'properties' ? i : found, -1);
    const latest = messagesRef.current[latestIndex];
    const page = visiblePropertyPage(latest);
    if (params.command === 'go_back') {
      const command = backCommand(getAssistantContext());
      if (!command) return 'You are already at the property results. Ask for more homes or change your search.';
      params = {...params, command};
    }
    if (['return_to_results','show_results'].includes(params.command)) {
      setExpandedMap(null);
      return discovery.run({...params,command:'show_results'},page);
    }
    if (params.command === 'return_to_property') {
      setExpandedMap(null);
      await discovery.run({command:'close_compare'},page);
      await discovery.run({command:'close_preferences'},page);
      return propertyModalRef.current?.run(params) || 'Choose a property number to open its details.';
    }
    if (params.command === 'close_map' && expandedMap) {
      setExpandedMap(null);
      return selectedPropertyRef.current ? 'Back to the property details.' : 'Back to the property results.';
    }
    if (['zoom_map_in','zoom_map_out'].includes(params.command) && isGlobeMap && globeMap && mapView && !selectedPropertyRef.current && !expandedMap) return zoomMap(globeLeafletRef.current,params.command==='zoom_map_in'?1:-1);
    if (params.command==='close_map' && isGlobeMap && globeMap && mapView && !selectedPropertyRef.current && !expandedMap) {setMapView(false);return 'Back to the property list.';}
    if (['zoom_map_in','zoom_map_out'].includes(params.command) && expandedMap)
      return zoomMap(leafletMapRef.current, params.command === 'zoom_map_in' ? 1 : -1);
    if (params.command === 'open_map' && (params.map_scope === 'results' || (params.number == null && !selectedPropertyRef.current))) {
      const points = mapPagePoints(page);
      if (!points.length) return page.length ? 'These homes do not have usable map coordinates.' : 'Search for homes first, then ask to see them on the map.';
      await discovery.run({command:'close_compare'},page);
      await discovery.run({command:'close_preferences'},page);
      propertyModalRef.current?.run({command:'return_to_property'});
      setExpandedMap({...points[0],points,address:'Current search results'});
      return `The map shows ${points.length} of the ${page.length} homes on this page, using the same card numbers. Say zoom in, zoom out, or go back.`;
    }
    if (['open_property','open_map','open_photos','show_room','open_nearby','find_nearby','next_page','previous_page','close_property','show_favorites'].includes(params.command)) setExpandedMap(null);
    if(params.command==='add_compare' && params.number==null && !params.numbers && selectedPropertyRef.current)return discovery.add([selectedPropertyRef.current]);
    const discoveryResult = await discovery.run(params,page);
    if(discoveryResult !== null)return discoveryResult;
    const property = params.number == null ? selectedPropertyRef.current : page[params.number - 1];
    if (params.command === 'next_page') {
      if (!latest) return 'Search for some homes first.';
      if (!latest.hasMore && ((latest.currentPage || 0) + 1) * itemsPerPage >= latest.properties.length) return 'You are on the last page of results.';
      setPropertyDetail(null); detailGenerationRef.current += 1;
      const result = await handleShowMoreProperties(latestIndex);
      return result || await confirmResults(latest.searchId, (latest.currentPage || 0) + 1, options.isCurrent);
    }
    if (params.command === 'previous_page') {
      if (!latest || !latest.currentPage) return 'You are on the first page of results.';
      setPropertyDetail(null); detailGenerationRef.current += 1;
      setMessages(prev => prev.map((m, i) => i === latestIndex ? { ...m, currentPage: m.currentPage - 1 } : m));
      return confirmResults(latest.searchId, latest.currentPage - 1, options.isCurrent);
    }
    if (params.command === 'close_property') { detailGenerationRef.current += 1; setPropertyDetail(null); return 'Back to the property results.'; }
    if (['open_property', 'open_map', 'open_photos', 'save_property', 'prepare_email', 'open_showing', 'open_nearby', 'find_nearby', 'show_room'].includes(params.command)) {
      if (!property) return 'Which property number on this page would you like?';
      if (params.command === 'save_property') {
        return beginAssistantSave(property, user);
      }
      if (property.listing_key !== selectedPropertyRef.current?.listing_key) {
        if (property.isPrivate) await fetchPrivatePropertyDetail(property);
        else await fetchPropertyDetail(property.id, property);
        // A frame is not proof that an async property render mounted. Check the actual home.
        const mounted = await waitForScreen(() => [...document.querySelectorAll('[data-assistant-surface="property"]')].some(el => el.dataset.listingKey === String(property.listing_key) && surfaceVisible(el)), options.isCurrent, 4000);
        if (!mounted) return 'The property details did not finish opening. Please try again from the current screen.';
      }
      if (options.isCurrent && !options.isCurrent()) return 'The request was superseded by your latest action.';
      if (params.command === 'open_property') {
        // The model can use open_property to return to the selected home.
        // Unwind its photo/form overlays even when no new listing is loaded.
        await propertyModalRef.current?.run({command:'return_to_property'});
        return 'The property details are open. What would you like to know?';
      }
    }
    if (!selectedPropertyRef.current && params.command !== 'prepare_email') return 'Open a property first.';
    return propertyModalRef.current?.run({...params,isCurrent:options.isCurrent}) || 'The detail screen is loading. Please try again.';
  };

const handleAction = async (action, params = {}, options = {}) => {
    if (options.reviewSeller && ['seller_inquiry','collecting_seller_info'].includes(action)) {
      const supplied={...params,phone:params.phone || params.phoneNumber || params.phone_number};
      const current=sellerReviewRef.current?.context().seller_review_draft || {};
      const draft={name:current.name || name || user?.username || '',email:current.email || email || user?.email || '',phone:current.phone || phoneNumber || user?.phoneNumber || ''};
      for (const [key,value] of Object.entries(supplied)) if(typeof value==='string' && value.trim()) draft[key]=value;
      const result=sellerReviewRef.current?.open(draft) || 'The selling review is loading. Nothing has been sent.';
      return acknowledgeScreenAction({command:'open_seller_review',result,getContext:()=>currentContextRef.current(),isCurrent:options.isCurrent});
    }
    // Close any existing forms first
    setShowRegistration(false);
    setShowLogin(false);

    if (action === 'show_registration') {
      setRegEmail(params.email || '');
      setRegName(params.name || '');
      setShowRegistration(true);
    } else if (action === 'show_login') {
      setLoginUsername(params.email || '');
      setShowLogin(true);
    } else if (action === 'show_map') {
      return fetchProperties(params, options);
    } else if (action === 'collecting_buyer_info') {
      // The assistant is clarifying a request, not asking us to search.
      return;
    } else if (action === 'get_liked_properties') {
      if(assistantEnabled)return discovery.showFavorites();
      fetchLikedProperties();
    } else if (action === 'seller_inquiry') {
      // Contact details the visitor shared in conversation arrive on the action params;
      // prefer those over possibly stale local state, then fall back to the capture form.
      const paramName = params.name || '';
      const paramPhone = params.phone || params.phoneNumber || params.phone_number || '';
      const paramEmail = params.email || '';
      if (paramName) setName(paramName);
      if (paramPhone) setPhoneNumber(paramPhone);
      if (paramEmail) setEmail(paramEmail);

      const userEmail = user?.email || paramEmail || email;
      const userName = user?.username || paramName || name;
      const userPhone = user?.phoneNumber || paramPhone || phoneNumber;

      if (userName && userPhone && userEmail) {
        submitSellerInquiry(params, userEmail, userName, userPhone);
        setChatLeadSubmitted(true);
        localStorage.setItem('leadInfo', JSON.stringify({ name: userName, email: userEmail, phone: userPhone }));
      } else {
        setPendingSellerParams(params);
        setMessages(prev => [...prev, { type: 'bot', content: 'seller_lead_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'buying_inquiry') {
      // Per the chat spec, buying_inquiry = serious purchase intent = a LEAD moment, NOT a
      // property browse (browsing/searching returns show_map, which is what renders listings).
      // Contact details shared in conversation arrive on the params (conversational_contact
      // capability, same as the seller flow); use them before falling back to the form.
      const paramName = params.name || '';
      const paramPhone = params.phone || params.phoneNumber || params.phone_number || '';
      const paramEmail = params.email || '';
      if (paramName) setName(paramName);
      if (paramPhone) setPhoneNumber(paramPhone);
      if (paramEmail) setEmail(paramEmail);

      if (user || chatLeadSubmitted) {
        // Known lead: the bot's reply normally drives the next step, but contact info
        // typed into the conversation is deliberate (new or corrected) - record it once.
        if (paramName && paramPhone && paramEmail) {
          const signature = `${paramName}|${paramPhone}|${paramEmail}`;
          if (lastSubmittedLeadRef.current !== signature) {
            lastSubmittedLeadRef.current = signature;
            submitBuyerLead(params, paramName, paramPhone, paramEmail);
          }
        }
      } else {
        const leadName = paramName || name;
        const leadPhone = paramPhone || phoneNumber;
        const leadEmail = paramEmail || email;

        if (leadName && leadPhone && leadEmail) {
          lastSubmittedLeadRef.current = `${leadName}|${leadPhone}|${leadEmail}`;
          submitBuyerLead(params, leadName, leadPhone, leadEmail);
        } else {
          setPendingBuyerParams(params);
          setMessages(prev => [...prev, { type: 'bot', content: 'buyer_lead_capture' }]);
          setTimeout(scrollToBottom, 200);
        }
      }
    } else if (action === 'storeConvo') {
      storeConversation(params);
    } else if (action === 'get-crm') {
      handleGetCRM();
    } else if (action === 'agent_contact_request') {
      const userName = user?.username || name;
      const userPhone = user?.phoneNumber || phoneNumber;

      if (userName && userPhone) {
        sendAgentSMS(userName, userPhone);
      } else {
        setMessages(prev => [...prev, { type: 'bot', content: 'agent_contact_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'property_alert') {
      if (!nudgeStateRef.current.used.includes('alerts')) nudgeStateRef.current.used.push('alerts');
      const searchFilters = searchSnapshot(params.searchFilters || params);
      assertValidSearch(searchFilters);

      const subPayload = {
        customerName: params.name,
        agentName: SITE_CONFIG.AGENT.NAME,
        emailAddress: params.email,
        siteId: SITE_CONFIG.SITE_ID,
        cadence: params.cadence || 'daily',
        listingBaseUrl: window.location.origin,
        ...(senderEmail && { senderEmail }),
        ...(senderPassword && { emailPassword: senderPassword }),
        searchFilters,
      };

      const leadParams = new URLSearchParams({
        name: params.name,
        email: params.email,
        serviceReq: params.serviceReq || 'buying',
        siteId: SITE_CONFIG.SITE_ID,
      });
      if (params.postalCode) leadParams.set('postalCode', params.postalCode);
      if (params.phoneNumber) leadParams.set('phoneNumber', params.phoneNumber);
      if (params.city) leadParams.set('area', params.city);

      // Verification must finish before creating an alert. Await both responses
      // so text and voice report the application outcome, not the model's guess.
      try {
        const leadRes = await submitChatLead(leadParams, { rememberContact: true });
        if (!leadRes.ok || leadRes.honeypotBlocked) return 'Your contact could not be verified. The property alert has not been created. Please try again.';
      } catch (error) {
        return `${error.message || 'Your contact could not be saved.'} The property alert has not been created. Your details are still in this conversation.`;
      }
      if (options.isCurrent && !options.isCurrent()) return 'The request changed during verification. The property alert has not been created.';
      try {
        const subRes = await fetch('https://tophamtechbe.com/api/treas/comm/property-search-subscriptions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-API-Key': 'treas-api-key-2025' },
          body: JSON.stringify(subPayload),
        });
        if (!subRes.ok) {
          if (subRes.status >= 500) throw new Error('Uncertain subscription outcome');
          return 'Your contact was saved, but the property alert was not created. Please check your alert details and try again.';
        }
        return `Your ${subPayload.cadence} property alert is set up for ${params.email}. It uses the search criteria you selected.`;
      } catch {
        return 'Your contact was saved, but I could not confirm whether the property alert was created. Please check with the agent before trying again to avoid duplicate alerts.';
      }
    }
  };

const handleRegistrationSubmit = async (e) => {
    e.preventDefault();
    try {
      const analyticsIdentity = await getAnalyticsIdentityForAuth();
      const response = await signUp({
        username: regName,
        email: regEmail,
        password: regPassword,
        phoneNumber: regPhoneNumber,
        name: regFullName,
        siteId: SITE_CONFIG.SITE_ID,
        ...(analyticsIdentity ? { analyticsIdentity } : {})
      });

      if (response.ok) {
        // Registration successful, now sign them in automatically
        try {
          const signInResponse = await signIn({
            username: regName,
            password: regPassword,
            siteId: SITE_CONFIG.SITE_ID,
            ...(analyticsIdentity ? { analyticsIdentity } : {})
          });

          if (signInResponse.ok) {
            const userData = await signInResponse.json();
            setUser(userData);
            setIsAdmin(hasAdminAccess(userData));
            localStorage.setItem('user', JSON.stringify(userData));
            completeAnalyticsAuthentication(userData, 'sign_up');

            const botMessage = { type: 'bot', content: 'Registration successful! You are now signed in. How can I help you today?' };
            setMessages(prev => [...prev, botMessage]);
          } else {
            const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
            setMessages(prev => [...prev, botMessage]);
            setShowLogin(true);
          }
        } catch (error) {
          console.error('Auto sign-in error:', error);
          const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
          setMessages(prev => [...prev, botMessage]);
          setShowLogin(true);
        }

        setShowRegistration(false);
        setRegEmail('');
        setRegName('');
        setRegPassword('');
        setRegPhoneNumber('');
        setRegFullName('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Registration error response:', errorData);
        const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Registration error:', error);
      const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const analyticsIdentity = await getAnalyticsIdentityForAuth();
      const response = await signIn({
        username: loginUsername,
        password: loginPassword,
        siteId: SITE_CONFIG.SITE_ID,
        ...(analyticsIdentity ? { analyticsIdentity } : {})
      });

      if (response.ok) {
        const userData = await response.json();

        // Check if siteId matches
        if (userData.siteId?.toLowerCase() !== SITE_CONFIG.SITE_ID.toLowerCase()) {
          const botMessage = { type: 'bot', content: 'Access denied. You are not authorized for this site.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        // Set user data and check for admin role
        setUser(userData);
        setIsAdmin(hasAdminAccess(userData));
        localStorage.setItem('user', JSON.stringify(userData));
        completeAnalyticsAuthentication(userData, 'login');

        const botMessage = { type: 'bot', content: 'Login successful! Welcome back. How can I help you today?' };
        setMessages(prev => [...prev, botMessage]);
        setShowLogin(false);
        setLoginUsername('');
        setLoginPassword('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Login error response:', errorData);
        const botMessage = { type: 'bot', content: 'Login failed. Please check your credentials.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Login error:', error);
      const botMessage = { type: 'bot', content: 'Login failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await requestPasswordReset({
        email: resetEmail,
        baseUrl: window.location.origin,
        siteId: SITE_CONFIG.SITE_ID
      });

      if (response.ok) {
        const botMessage = { type: 'bot', content: 'Password reset link sent to your email. Please check your inbox.' };
        setMessages(prev => [...prev, botMessage]);
        setShowForgotPassword(false);
        setShowLogin(false);
        setResetEmail('');
      } else {
        const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

const fetchProperties = async (params, options = {}) => {
    chatAbortRef.current?.abort();
    const controller=new AbortController();chatAbortRef.current=controller;
    const snapshot = chatSearchSnapshot(params, SITE_CONFIG.STATE);
    const generation = chatGenerationRef.current;
    const requestId = ++chatPropertyRequestRef.current;
    const ownsRequest = () => generation === chatGenerationRef.current && requestId === chatPropertyRequestRef.current;
    const isCurrent = () => ownsRequest() && (!options.isCurrent || options.isCurrent());
    setIsPropertySearching(true);
    setPendingSearchFilters(snapshot);
    try {
      const result = await loadPropertyPage({
        pageSize: itemsPerPage, queryOptions:{firstPhoto:true}, signal:controller.signal,
        params: snapshot,
        siteId: SITE_CONFIG.SITE_ID,
        privateApiKey: 'treas-api-key-2025'
      });
      if (!isCurrent()) return;
      // Replace the entire prior search. Merging would resurrect removed filters.
      chatSearchContextRef.current = { siteId: chatSiteId, params: snapshot };
      setMessages(prev => [...prev, {
        type: 'bot',
        content: 'properties',
        properties: result.properties,
        privateUnavailable: result.privateUnavailable,
        searchMeta: result.searchMeta,
        pageState: result.pageState, hasMore: result.hasMore, searchFilters:snapshot, searchId:requestId,
        currentPage: 0
      }]);
      const confirmation = assistantEnabled ? await confirmResults(requestId, 0, isCurrent) : resultsAnnouncement({...result, currentPage:0});
      if (isCurrent() && !result.properties.length && snapshot.listAgentMlsId) return 'No properties matched this search. It is limited to agent listings. Say “remove the agent filter” to search other listings.';
      return confirmation;
    } catch (error) {
      if (!isCurrent()) return;
      console.error('Error fetching chat properties:', error);
      setMessages(prev => [...prev, {
        type: 'bot',
        content: error.message && error.message !== "MLS search unavailable" ? error.message : "I couldn't load the property search right now. Please try again."
      }]);
      return 'The property search could not load. Please try again.';
    } finally {
      if (ownsRequest()) {setIsPropertySearching(false);setPendingSearchFilters(null);}
    }
  };

const getTileCoords = (lat, lon, zoom) => {
    const x = Math.floor((lon + 180) / 360 * Math.pow(2, zoom));
    const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));
    return { x, y };
  };

const getPropertyCoords = (property) => {
    // Use actual lat/lon from property data, fallback to Austin coordinates
    const lat = property.latitude || 30.2672;
    const lon = property.longitude || -97.7431;
    return { lat, lon };
  };

const handleServiceSelect = (service) => {
    setSelectedService(service);
    setServiceStep(0);
    setShowThankYouMessage(false);
    setTimeout(scrollToBottom, 200);
  };

const handleServiceStepContinue = (event) => {
    event.preventDefault();
    if (serviceStep < 3) {
      setServiceStep((step) => step + 1);
      setTimeout(scrollToBottom, 160);
      return;
    }
    handleFormSubmit(event);
  };

const handleNewConversation = () => {
    if (saveContext().save_busy) return;
    if (saveContext().save_open) runAssistantSave({command:'cancel_save'});
    voice.stop();
    detailGenerationRef.current += 1;
    setPropertyDetail(null);
    chatAbortRef.current?.abort();moreRequestsRef.current.forEach(controller=>controller.abort());moreRequestsRef.current.clear();
    chatGenerationRef.current += 1;
    chatPropertyRequestRef.current += 1;
    chatSearchContextRef.current = null;
    setPendingSearchFilters(null);
    nudgeStateRef.current = newNudgeState();
    chatRequestInFlightRef.current = false;
    setMessages([]);
    setSelectedService(null);
    setServiceStep(0);
    setShowThankYouMessage(false);
    setShowRegistration(false);
    setShowLogin(false);
    setShowForgotPassword(false);
    setPendingBuyerParams(null);
    setPendingSellerParams(null);
    setInputValue('');
    setIsThinking(false);
    setIsPropertySearching(false);
    scrollMobileWorkspaceTo('chat', 'auto');
  };

const handleShowMoreProperties = async (messageIndex) => {
    const msg=messages[messageIndex];if(!msg||msg.loadingMore)return;
    const nextPage=(msg.currentPage||0)+1;
    if(!msg.pageState||nextPage*itemsPerPage<msg.properties.length) {
      setMessages(prev=>prev.map((item,index)=>index===messageIndex?{...item,currentPage:nextPage}:item));return;
    }
    if(!msg.hasMore||moreRequestsRef.current.has(msg.searchId))return;
    const generation=chatGenerationRef.current;const controller=new AbortController();moreRequestsRef.current.set(msg.searchId,controller);
    const update=change=>setMessages(prev=>prev.map(item=>item.searchId===msg.searchId&&item.content==='properties'?{...item,...change}:item));
    update({loadingMore:true,pageError:''});
    try {
      const result=await loadPropertyPage({params:msg.searchFilters,pageState:msg.pageState,signal:controller.signal,pageSize:itemsPerPage,siteId:SITE_CONFIG.SITE_ID,queryOptions:{firstPhoto:true},privateApiKey:'treas-api-key-2025'});
      if(generation!==chatGenerationRef.current)return;
      const seen=new Set(msg.properties.map(p=>p.listing_key));
      update({properties:[...msg.properties,...result.properties.filter(p=>!seen.has(p.listing_key))],pageState:result.pageState,hasMore:result.hasMore,currentPage:result.properties.length ? nextPage : (msg.currentPage || 0),loadingMore:false});
      if (!result.properties.length) return 'There are no more matching properties. You are still on the current page.';
    }catch(error){if(generation===chatGenerationRef.current&&error.name!=='AbortError')update({loadingMore:false,pageError:error.message,restartSearch:error.restartSearch});return 'The next page could not load. Please try again.';}
    finally{moreRequestsRef.current.delete(msg.searchId);}
  };

const markCaptureFormSubmitted = (content) => {
    setMessages(prev => prev.map(msg => msg.content === content ? { ...msg, submitted: true } : msg));
  };

const handleSellerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    if (!isHoneypotSubmission(e.currentTarget)) {
      await submitSellerInquiry(pendingSellerParams, email, name, phoneNumber);
    }
    setPendingSellerParams(null);
    setChatLeadSubmitted(true);
    localStorage.setItem('leadInfo', JSON.stringify({ name, email, phone: phoneNumber }));
    markCaptureFormSubmitted('seller_lead_capture');
    const botMessage = { type: 'bot', content: `Thanks ${name}! We've noted your property details and will be in touch shortly.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);
  };

const submitBuyerLead = async (buyerParams, leadName, leadPhone, leadEmail, form) => {
    const p = buyerParams || {};
    const area = p.city || zipCode;
    const postalCode = p.zip || (zipCode.match(/^\d{5}$/) ? zipCode : '');

    const leadParams = withHoneypotValue(new URLSearchParams({
      name: leadName,
      email: leadEmail,
      phoneNumber: leadPhone,
      serviceReq: 'buying',
      siteId: SITE_CONFIG.SITE_ID,
    }), form);
    if (area) leadParams.set('area', area);
    if (postalCode) leadParams.set('postalCode', postalCode);

    try {
      await submitChatLead(leadParams, { rememberContact: true });
    } catch (error) {
      console.error('Error submitting buyer lead:', error);
    }

    localStorage.setItem('leadInfo', JSON.stringify({ name: leadName, email: leadEmail, phone: leadPhone }));
    setChatLeadSubmitted(true);

    const searchParams = {...p};
    if (!searchParams.city && !searchParams.zip && zipCode) searchParams.zip = zipCode;
    if (!searchParams.maxPrice && maxPrice) searchParams.maxPrice = maxPrice;
    fetchProperties(searchParams);
    setMessages(prev => [...prev, { type: 'bot', content: `Thanks ${leadName}! Here are properties matching your search.` }]);
    setTimeout(scrollToBottom, 200);
  };

const handleBuyerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    markCaptureFormSubmitted('buyer_lead_capture');
    const buyerParams = pendingBuyerParams;
    setPendingBuyerParams(null);
    await submitBuyerLead(buyerParams, name, phoneNumber, email, e.currentTarget);
  };

const handleSellingFormSubmit = async (e) => {
    e.preventDefault();

    if (!isHoneypotSubmission(e.currentTarget)) {
      try {
        const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-details?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&phoneNumber=${encodeURIComponent(phoneNumber)}&address=${encodeURIComponent(propertyLocation)}&size=${encodeURIComponent(propertySize)}&condition=${encodeURIComponent(propertyCondition)}&timeline=${encodeURIComponent(sellingTimeline)}&siteId=${SITE_CONFIG.SITE_ID}`, {
          method: 'POST',
          headers: {
            'X-API-Key': 'treas-api-key-2025'
          }
        });

        if (response.ok) {
          console.log('Selling details submitted successfully');
        } else {
          console.error('Failed to submit selling details');
        }
      } catch (error) {
        console.error('Error submitting selling details:', error);
      }
    }

    // Show completion message
    const botMessage = { type: 'bot', content: `Thank you! I have all the details about your property. Agent Laura will contact you soon to discuss selling your ${propertySize} property in ${propertyLocation}.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);

    // Clear selling form but keep chat enabled
    setPropertyLocation('');
    setPropertySize('');
    setPropertyCondition('');
    setSellingTimeline('');
    // Don't set showThankYouMessage to false - keep send button enabled
  };

const fetchPrivatePropertyDetail = async (listing) => {
    const detailGeneration = ++detailGenerationRef.current;
    setPropertyMedia([]);
    setPropertyDetailImages([]);
    setImagesLoading(true);

    const listingId = String(listing.listing_key).replace('PRIVATE_', '');

    // If listing data is incomplete (e.g. coming from a direct URL), fetch it first
    let fullListing = listing;
    if (!listing.current_price && !listing.address) {
      try {
        const detailResponse = await fetch(`https://tophamtechbe.com/api/treas/private/v1/listing/${listingId}?site_id=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'x-api-key': 'treas-api-key-2025' }
        });
        if (detailResponse.ok) {
          const detailData = await detailResponse.json();
          if (detailGeneration !== detailGenerationRef.current) return;
          const d = detailData.listing || detailData;
          fullListing = {
            ...d,
            listing_key: `PRIVATE_${d.id}`,
            current_price: d.listing_type === 'sale' ? d.price_sale : d.price_lease_monthly,
            bedrooms_total: d.beds,
            address: `${d.address_line_1}, ${d.city}, ${d.state_province}`,
            isPrivate: true
          };
        }
      } catch (error) {
        console.error('Error fetching private listing detail:', error);
      }
    }

    try {
      const mediaResponse = await fetch(`https://tophamtechbe.com/api/treas/media/private/v1/media/${SITE_CONFIG.SITE_ID}/${listingId}`, {
        headers: { 'x-api-key': 'treas-api-key-2025' }
      });

      if (mediaResponse.ok) {
        const mediaData = await mediaResponse.json();
        if (detailGeneration !== detailGenerationRef.current) return;
        const sorted = (mediaData.media || []).sort((a, b) => a.order_hint - b.order_hint);
        setPropertyDetailImages(sorted.map(img => img.media_url || img.s3_link));
      }
    } catch (error) {
      console.error('Error fetching private property media:', error);
    } finally {
      if (detailGeneration === detailGenerationRef.current) setImagesLoading(false);
    }

    if (detailGeneration !== detailGenerationRef.current) return;
    const address = fullListing.address || '';
    setPropertyDetail({
      ...fullListing,
      listing_key: fullListing.listing_key,
      current_price: fullListing.current_price,
      bedrooms_total: fullListing.bedrooms_total,
      virtual_tour_url: fullListing.virtual_tour_url,
      created_at: fullListing.created_at,
      updated_at: fullListing.updated_at,
      location: {
        street_number: address.split(',')[0] || '',
        city: fullListing.city || '',
        state: fullListing.state_province || '',
        postal_code: fullListing.postal_code || ''
      },
      features: {
        public_remarks: fullListing.description || ''
      },
      isPrivate: true
    });
  };

const warmedImageUrls = useRef(new Set());

const prefetchPropertyDetail = (property) => {
    if (navigator.connection?.saveData) return;
    warmImage(property?.first_photo_url);
  };

const warmImage = (url) => {
    if (!url || warmedImageUrls.current.has(url)) return;
    warmedImageUrls.current.add(url);
    const im = new Image();
    im.src = url;
  };

React.useEffect(() => {
    const conn = navigator.connection || {};
    if (conn.saveData) return;
    messages.forEach((msg) => {
      if (msg?.content !== 'properties' || !Array.isArray(msg.properties)) return;
      const page = msg.currentPage || 0;
      const visibleEnd = (page + 1) * itemsPerPage;
      const nextEnd = (page + 2) * itemsPerPage;
      msg.properties.slice(0, visibleEnd).forEach((p) => prefetchPropertyDetail(p));
      msg.properties.slice(visibleEnd, nextEnd).forEach((p) => {
        prefetchPropertyDetail(p);
        warmImage(p?.first_photo_url);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, itemsPerPage]);

const fetchPropertyDetail = async (propertyId, summaryData) => {
    const detailGeneration = ++detailGenerationRef.current;
    setPropertyMedia([]);
    // Optimistic open: paint the modal INSTANTLY from the summary the clicked tile/pill
    // already has (price, address, and the first photo — already cached as the thumbnail),
    // so it doesn't wait on the (sometimes cold) detail round-trip. Enrich below.
    if (summaryData) {
      setPropertyDetail({
        ...summaryData,
        location: {
          street_number: summaryData.street_number,
          street_dir_prefix: summaryData.street_dir_prefix,
          street_suffix: summaryData.street_suffix,
          street_dir_suffix: summaryData.street_dir_suffix,
          unit_number: summaryData.unit_number,

          street_name: summaryData.street_name,
          city: summaryData.city,
          state: summaryData.state,
          postal_code: summaryData.postal_code
        },
        features: summaryData.features || {}
      });
      setPropertyDetailImages(summaryData.first_photo_url ? [summaryData.first_photo_url] : []);
      setImagesLoading(!summaryData.first_photo_url);
    } else {
      setPropertyDetailImages([]);
      setImagesLoading(true);
    }

    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-data/${propertyId}`);

      if (response.ok) {
        const data = await response.json();
        const property = data.properties[0];
        if (detailGeneration !== detailGenerationRef.current) return;
        setPropertyDetail({
          ...property,
          created_at: property.created_at || summaryData?.created_at,
          updated_at: property.updated_at || summaryData?.updated_at
        });

        // Fetch all images for the property detail view
        if (property.listing_key) {
          fetchAllPropertyImages(property.listing_key, detailGeneration);
        }
      } else {
        console.error('Failed to fetch property details');
        if (detailGeneration === detailGenerationRef.current) setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching property details:', error);
      if (detailGeneration === detailGenerationRef.current) setImagesLoading(false);
    }
  };

const fetchAllPropertyImages = async (listingKey, detailGeneration = detailGenerationRef.current) => {
    try {
      const media = await loadPropertyMedia(listingKey);
      if (detailGeneration !== detailGenerationRef.current) return;
      const images = propertyMediaUrls(media);
      if (images.length > 0) {
          const firstThree = images.slice(0, 3);
          setPropertyDetailImages(firstThree);
          setPropertyMedia(media.slice(0,3));
          setImagesLoading(false);
          rememberPropertyPhoto(listingKey, images[0]);
          if (images.length > 3) {
            setTimeout(() => {
              if (detailGeneration !== detailGenerationRef.current) return;
              setPropertyDetailImages(images);
              setPropertyMedia(media);
            }, 500);
          }
      } else {
        setImagesLoading(false);
      }
    } catch (error) {
      if (detailGeneration !== detailGenerationRef.current) return;
      console.error('Error fetching all property images:', error);
      setImagesLoading(false);
    }
  };

const propertyDetailOverlay = (
    <PropertyDetailModal
      propertyDetail={propertyDetail}
      assistantEnabled={assistantEnabled}
      assistantControlRef={propertyModalRef}
      onAssistantState={onDetailUi}
      onAssistantResult={assistantResult}
      selectedNumber={getAssistantContext().selected_number}
      onAssistantMessage={processAssistantMessage}
      assistantBusy={isThinking || isPropertySearching}
      voiceActive={voice.active}
      propertyDetailImages={propertyDetailImages}
      propertyMedia={propertyMedia}
      imagesLoading={imagesLoading}
      onClose={() => {
        detailGenerationRef.current += 1;
        setPropertyDetail(null);
        if (directListingKey) navigate((directListingReturnTo?.startsWith('/properties/list') || directListingReturnTo?.startsWith('/area/')) ? directListingReturnTo : '/', {state:directListingReturnState});
      }}
      user={user}
      isAdmin={isAdmin}
      likedProperties={likedProperties}
      setLikedProperties={setLikedProperties}
      senderEmail={senderEmail}
      senderPassword={senderPassword}
      onLeadCaptured={({ name: capturedName, email: capturedEmail, phone }) => {
        setName(capturedName);
        setEmail(capturedEmail);
        setPhoneNumber(phone);
      }}
    />
  );

useEffect(() => {
    const latestPropertyMessageIndex = messages.reduce(
      (latestIndex, message, index) => message.content === 'properties' ? index : latestIndex,
      -1
    );

    if (latestPropertyMessageIndex < 0) {
      lastMobilePropertyResultRef.current = '';
      setMobileWorkspaceView('chat');
      return undefined;
    }

    const latestPropertyMessage = messages[latestPropertyMessageIndex];
    const resultKey = `${latestPropertyMessageIndex}:${latestPropertyMessage.properties?.length || 0}`;
    if (lastMobilePropertyResultRef.current === resultKey) return undefined;
    lastMobilePropertyResultRef.current = resultKey;

    if (window.location.pathname === '/chat' || !window.matchMedia('(max-width: 820px)').matches) return undefined;
    setMobileWorkspaceView('results');

    const frame = window.requestAnimationFrame(() => {
      const workspace = assistantWorkspaceRef.current;
      if (!workspace) return;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      workspace.scrollTo({
        left: Math.max(0, workspace.scrollWidth - workspace.clientWidth),
        behavior
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [messages]);

useEffect(() => {
    const pending = pendingPropertyRevealRef.current;
    if (!pending) return undefined;
    const latest = [...messages].reverse().find(message => message.content === 'properties');
    if (!latest || latest.searchId !== pending.searchId || latest.pageError) {
      pendingPropertyRevealRef.current = null;
      return undefined;
    }
    if (latest.loadingMore) return undefined;
    const rail = assistantPropertyRailRef.current;
    const card = rail?.querySelector(`[data-property-index="${pending.index}"]`);
    if (!card) {
      pendingPropertyRevealRef.current = null;
      return undefined;
    }
    const frame = window.requestAnimationFrame(() => {
      if (pendingPropertyRevealRef.current !== pending) return;
      pendingPropertyRevealRef.current = null;
      const mobile = window.matchMedia('(max-width: 820px)').matches;
      const panel = assistantResultsPanelRef.current;
      if (!panel || (mobile && assistantWorkspaceRef.current?.scrollLeft < 20)) return;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (document.activeElement?.closest('.assistant-results-load-more')) {
        card.querySelector('button')?.focus({ preventScroll: true });
      }
      if (mobile) {
        rail.scrollTo({ left: rail.scrollLeft + card.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior });
      } else {
        const target = assistantEnabled ? panel.querySelector('.assistant-page-controls') || card : card;
        panel.scrollTo({ top: Math.max(0, panel.scrollTop + target.getBoundingClientRect().top - panel.getBoundingClientRect().top - (assistantEnabled ? 16 : 72)), behavior });
      }
    });
    return () => window.cancelAnimationFrame(frame);
  }, [messages]);

const latestPropertyMessageIndex = messages.reduce(
    (latestIndex, message, index) => message.content === 'properties' ? index : latestIndex,
    -1
  );

const latestPropertyMessage = latestPropertyMessageIndex >= 0 ? messages[latestPropertyMessageIndex] : null;

const visibleWorkspaceProperties = latestPropertyMessage
    ? (assistantEnabled ? visiblePropertyPage(latestPropertyMessage) : latestPropertyMessage.properties.slice(0, ((latestPropertyMessage.currentPage || 0) + 1) * itemsPerPage))
    : [];

const hasPropertyWorkspace = isFullPage && visibleWorkspaceProperties.length > 0;

const remainingWorkspaceProperties = latestPropertyMessage
    ? Math.max(0, latestPropertyMessage.properties.length - (assistantEnabled ? ((latestPropertyMessage.currentPage || 0) + 1) * itemsPerPage : visibleWorkspaceProperties.length)) + (latestPropertyMessage.hasMore ? itemsPerPage : 0)
    : 0;

const nextWorkspacePropertyCount = Math.min(itemsPerPage, remainingWorkspaceProperties);

const hasConversationStarted = Boolean(
    selectedService ||
    messages.length ||
    showThankYouMessage ||
    showRegistration ||
    showLogin ||
    showForgotPassword ||
    isThinking ||
    isPropertySearching
  );

const identity = assistantIdentity(SITE_CONFIG);

const assistantName = identity.label;

const assistantActivity = isPropertySearching ? 'Searching live listings' : isThinking ? 'Thinking' : 'Ready to help';

const formatPropertyPrice = (value) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) : value;
  };

const getPropertyAddress = (property) => formatPropertyAddress(property);

const getPropertyKey = (property, index) => property.listing_key || property.id || index;

const toggleWorkspaceFavorite = (property) => toggleFavorite(property, user);

const handleWorkspaceShowMore = () => {
    if (latestPropertyMessage.loadingMore) return;
    pendingPropertyRevealRef.current = {
      searchId: latestPropertyMessage.searchId,
      index: assistantEnabled ? 0 : visibleWorkspaceProperties.length
    };
    handleShowMoreProperties(latestPropertyMessageIndex);
  };

const renderPropertyPagination = position => assistantEnabled && latestPropertyMessage && (
    <nav className="assistant-page-controls" aria-label={`Property pages, ${position} of results`}>
      <button type="button" className="assistant-page-previous" disabled={!latestPropertyMessage.currentPage || latestPropertyMessage.loadingMore} onClick={() => setMessages(prev => prev.map((m, i) => i === latestPropertyMessageIndex ? { ...m, currentPage: m.currentPage - 1 } : m))}>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6M8 12h12" /></svg>
        <span>Previous 6 properties</span>
      </button>
      <span className="assistant-page-position">Page <strong>{(latestPropertyMessage.currentPage || 0) + 1}</strong></span>
      <button type="button" className="assistant-page-next" disabled={!remainingWorkspaceProperties || latestPropertyMessage.loadingMore} onClick={handleWorkspaceShowMore}>
        <span>{latestPropertyMessage.loadingMore ? 'Loading…' : 'Show next 6 properties'}</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6M4 12h12" /></svg>
      </button>
      <small className="assistant-page-hint">{resultsContext(latestPropertyMessage).results_has_more ? 'More results available · ' : 'Last page · '}Say “next page” or “previous page” to browse. Say “open number three” to see a home.</small>
    </nav>
  );

return (
    <div className={`action-buttons-container ${isFullPage ? 'assistant-full-page' : ''} ${hasPropertyWorkspace ? 'assistant-has-results' : ''} ${hasConversationStarted ? 'assistant-conversation-started' : 'assistant-chat-empty'}`} role="region" aria-label="Real estate chat assistant">
      <div className={`chat-box assistant-shell ${isDarkMode ? 'dark-mode' : ''}`} role="complementary">
        {isFullPage && (
          <header className="assistant-header">
            <div className="assistant-header-primary">
              {onBack && (
                <button type="button" className="assistant-header-back" onClick={onBack} aria-label="Back to home">
                  <span aria-hidden="true">←</span>
                </button>
              )}
              <div className="assistant-header-avatar" aria-hidden="true">
                <img src={SITE_CONFIG.LANDING_PAGE?.AGENT_IMAGE || SITE_CONFIG.AGENT.IMAGE || undefined} alt="" />
                <span></span>
              </div>
              <div className="assistant-header-identity">
                <strong>{assistantName}</strong>
                <span><i className={isThinking || isPropertySearching ? 'assistant-status-busy' : ''}></i>{assistantActivity}</span>
              </div>
            </div>
            <div className="assistant-header-context">
              <span className="assistant-live-listings-badge">Live listings</span>
              {user ? (
                <span className="assistant-user-state">Welcome, {user.username || user.name || 'back'}</span>
              ) : (
                <button type="button" className="assistant-account-button" onClick={() => { setShowRegistration(false); setShowForgotPassword(false); setShowLogin(true); }}>
                  Sign in
                </button>
              )}
              <button type="button" className="assistant-new-chat" onClick={handleNewConversation}>New conversation</button>
            </div>
          </header>
        )}
        {hasPropertyWorkspace && (
          <nav className="assistant-mobile-workspace-tabs" aria-label="Switch between chat and property results">
            <button type="button" className={mobileWorkspaceView === 'chat' ? 'is-active' : ''} onClick={() => scrollMobileWorkspaceTo('chat')} aria-label="Return to chat conversation" aria-pressed={mobileWorkspaceView === 'chat'}>
              ← Chat
            </button>
            <button type="button" className={mobileWorkspaceView === 'results' ? 'is-active' : ''} onClick={() => scrollMobileWorkspaceTo('results')} aria-pressed={mobileWorkspaceView === 'results'}>
              Homes <span>{latestPropertyMessage.properties.length}</span>
            </button>
          </nav>
        )}
        <div className="assistant-workspace" ref={assistantWorkspaceRef} onScroll={handleMobileWorkspaceScroll}>
          <section className="assistant-conversation-pane" aria-label={`Conversation with ${assistantName}`}>
        <div className="chat-messages" ref={messagesContainerRef} role="log" aria-live="polite" aria-label="Chat conversation history">
          <div className="message bot-message welcome-message">
            <div className="assistant-welcome-kicker">
              <span></span>
              {SITE_CONFIG.ASSISTANT?.BRAND_NAME || SITE_CONFIG.AGENT.BROKERAGE || SITE_CONFIG.AGENT.NAME} · AI real estate assistant
            </div>
            <div className="welcome-text">
              <h1>{isFullPage ? <>What can I <em>help you with?</em></> : <>Welcome. <em>Let’s talk.</em></>}</h1>
              <p>{isFullPage ? `I’m ${SITE_CONFIG.ASSISTANT?.BRAND_NAME || SITE_CONFIG.AGENT.NAME}’s AI assistant. I can help you find homes, plan your sale, or contact ${SITE_CONFIG.AGENT.NAME}.` : identity.welcome}</p>
            </div>
            {!isFullPage && <div className="service-buttons assistant-intent-grid">
              <div className="button-row assistant-primary-intents">
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('buying')}
                  aria-label="Select buying service to search for properties to purchase"
                >
                  <span className="assistant-intent-number">01</span>
                  <span><strong>Find a home</strong><small>Search live listings with guidance</small></span>
                  <span className="assistant-intent-arrow" aria-hidden="true">↗</span>
                </button>
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('selling')}
                  aria-label="Select selling service to list your property for sale"
                >
                  <span className="assistant-intent-number">02</span>
                  <span><strong>Sell my home</strong><small>Share details and plan your next move</small></span>
                  <span className="assistant-intent-arrow" aria-hidden="true">↗</span>
                </button>
              </div>
              <div className="button-row assistant-secondary-intents">
                <button
                  className="service-button"
                  onClick={() => handleServiceSelect('lease')}
                  aria-label="Select lease service to find rental properties"
                >
                  Lease a home
                </button>
                <button
                  className="service-button"
                  onClick={() => handlePromptSelect('Help me create a property alert')}
                  aria-label="Create a personalized property alert"
                >
                  Create an alert
                </button>
                <button
                  className="service-button"
                  onClick={() => handlePromptSelect(`Contact ${SITE_CONFIG.AGENT.NAME}`)}
                  aria-label={`Connect with ${SITE_CONFIG.AGENT.NAME}`}
                >
                  Talk to {SITE_CONFIG.AGENT.NAME}
                </button>
              </div>
            </div>}
            {!isFullPage && <div className="assistant-welcome-trust">
              <span>Connected to live MLS data</span>
              <span>Private and pressure-free</span>
              <span>Human help whenever you want it</span>
            </div>}
          </div>

          {selectedService && !showThankYouMessage && (
            <div className="message bot-message assistant-guided-step">
              <div className="assistant-step-heading">
                <div>
                  <span>{selectedService === 'selling' ? 'Seller consultation' : selectedService === 'lease' ? 'Lease search' : 'Buyer search'}</span>
                  <h3 className="form-title">
                    {serviceStep === 0 && (selectedService === 'selling' ? 'Where is the property?' : 'Where would you like to look?')}
                    {serviceStep === 1 && 'What should I call you?'}
                    {serviceStep === 2 && 'Where should I send your matches?'}
                    {serviceStep === 3 && 'What is the best number for you?'}
                  </h3>
                </div>
                <span className="assistant-step-count">{serviceStep + 1} / 4</span>
              </div>
              <div className="assistant-step-progress" aria-hidden="true"><span style={{width: `${((serviceStep + 1) / 4) * 100}%`}}></span></div>
              <p className="form-subtitle">
                {serviceStep === 0 && (selectedService === 'selling' ? 'A street address or neighborhood is perfect.' : 'Enter a local city, neighborhood, or ZIP code.')}
                {serviceStep === 1 && 'I’ll use this to personalize the conversation.'}
                {serviceStep === 2 && 'Your email lets me save the search and send new matches if you choose.'}
                {serviceStep === 3 && `Only ${SITE_CONFIG.AGENT.NAME}'s team will receive your information.`}
              </p>
              <form className="chat-form assistant-step-form" onSubmit={handleServiceStepContinue}>
                <HoneypotField />
                {serviceStep === 0 && (
                  <input type="text" placeholder="City, neighborhood, or ZIP code" value={zipCode} onChange={(e) => setZipCode(e.target.value)} className="form-input" autoFocus required />
                )}
                {serviceStep === 1 && (
                  <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" autoFocus required />
                )}
                {serviceStep === 2 && (
                  <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" autoFocus required />
                )}
                {serviceStep === 3 && (
                  <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" autoFocus required />
                )}
                <div className="assistant-step-actions">
                  {serviceStep > 0 && <button type="button" className="assistant-step-back" onClick={() => setServiceStep((step) => step - 1)}>Back</button>}
                  <button type="submit" className="form-submit cta-button" aria-label={serviceStep === 3 ? 'Submit your information and continue' : 'Continue to the next question'}>
                    {serviceStep === 3 ? 'Continue' : 'Next'} <span aria-hidden="true">→</span>
                  </button>
                </div>
              </form>
              <div className="assistant-step-summary">
                {zipCode && serviceStep > 0 && <span><small>Area</small>{zipCode}</span>}
                {name && serviceStep > 1 && <span><small>Name</small>{name}</span>}
                {email && serviceStep > 2 && <span><small>Email</small>{email}</span>}
              </div>
            </div>
          )}
          {showThankYouMessage && (
            <div className="message bot-message">
              {selectedService === 'buying' ? (
                <div>
                  <p>Thank you, {name}! Since you're looking to buy, would you like to see some properties for sale in {zipCode}?</p>
                  <div className="service-buttons">
                    <button className="service-button" onClick={() => { console.log('Fetching properties for zip:', zipCode); fetchProperties({zip: zipCode}); }}>Yes, Show Properties</button>
                    <button className="service-button" onClick={() => setShowThankYouMessage(false)}>Not Right Now</button>
                  </div>
                </div>
              ) : selectedService === 'selling' ? (
                <div>
                  <p>Thank you, {name}! Let's get some details about your property to help with the selling process.</p>
                  <form className="chat-form" onSubmit={handleSellingFormSubmit}>
                    <HoneypotField />
                    <input
                      type="text"
                      placeholder="Property location/address"
                      value={propertyLocation}
                      onChange={(e) => setPropertyLocation(e.target.value)}
                      className="form-input"
                      required
                    />
                    <input
                      type="text"
                      placeholder="Property size (e.g., 3 bed, 2 bath)"
                      value={propertySize}
                      onChange={(e) => setPropertySize(e.target.value)}
                      className="form-input"
                      required
                    />
                    <select
                      value={propertyCondition}
                      onChange={(e) => setPropertyCondition(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select property condition</option>
                      <option value="excellent">Excellent</option>
                      <option value="good">Good</option>
                      <option value="fair">Fair</option>
                      <option value="needs-work">Needs Work</option>
                    </select>
                    <select
                      value={sellingTimeline}
                      onChange={(e) => setSellingTimeline(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select timeline</option>
                      <option value="asap">ASAP</option>
                      <option value="1-3-months">1-3 months</option>
                      <option value="3-6-months">3-6 months</option>
                      <option value="6-months-plus">6+ months</option>
                    </select>
                    <button type="submit" className="form-submit cta-button">Submit Property Details</button>
                  </form>
                </div>
              ) : selectedService === 'lease' ? (
                <p>Thank you, {name}! How else can I help you today?</p>
              ) : (
                <p>Thank you, {name}! How else can I help you today?</p>
              )}
            </div>
          )}
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.type === 'user' ? 'user-message' : 'bot-message'} ${message.content === 'properties' ? 'property-results-message' : ''}`}>
              {message.type !== 'user' && message.content !== 'properties' && <span className="assistant-message-author">{assistantName}</span>}
              {message.sources?.length > 0 && <div>{message.sources.filter(source => /^https:\/\//.test(source.url)).map(source => <a key={source.url} href={source.url} target="_blank" rel="noopener noreferrer">{source.title || 'Source'} </a>)}</div>}
              {message.content === 'properties' ? (
                <div>
                  {message.properties.length > 0
                    ? `Found ${message.properties.length} properties:`
                    : message.privateUnavailable
                      ? 'No MLS properties matched this search.'
                      : 'No properties matched this search. Try changing a feature, budget, or location.'}
                  {message.privateUnavailable && (
                    <p role="status">Private listings could not be loaded. These results include MLS listings only.</p>
                  )}
                  {message.properties.length > itemsPerPage && (
                    <div style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                      {Math.min(((message.currentPage || 0) + 1) * itemsPerPage, message.properties.length)} homes shown{message.hasMore ? ". More homes available." : ""}
                    </div>
                  )}
                  <div className="properties-list" data-results-search={message.searchId} data-results-page={message.currentPage || 0}>
                    {(assistantEnabled ? visiblePropertyPage(message) : message.properties.slice(0, ((message.currentPage || 0) + 1) * itemsPerPage)).map((property, propIndex) => (
                      <div key={propIndex} data-result-card className="property-item" role="article" aria-label={`Property listing: ${property.address || property.street_address || 'Property'} - $${property.current_price || property.price}`}>
                        <script type="application/ld+json">
                          {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "RealEstateProperty",
                            "name": formatPropertyAddress(property),
                            "address": {
                              "@type": "PostalAddress",
                              "streetAddress": formatStreetAddress(property),
                              "addressLocality": property.city,
                              "addressRegion": property.state,
                              "postalCode": property.postal_code
                            },
                            "price": property.current_price || property.price,
                            "priceCurrency": "USD",
                            "numberOfRooms": property.bedrooms_total || property.bedrooms,
                            "propertyType": property.property_type,
                            "url": `${window.location.origin}/listing/${property.listing_key}`
                          })}
                        </script>
                        {assistantEnabled && <span className="assistant-property-number">{propIndex + 1}</span>}
                        <div className="property-map">
                          <div
                            className="mini-map clickable"
                            onClick={() => setExpandedMap({...getPropertyCoords(property), address: property.address || `Property ${property.id}`})}
                          >
                            <img
                              src={`https://tile.openstreetmap.org/15/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).x}/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).y}.png`}
                              alt={`Map tile showing location of ${property.address || 'property'}`}
                              className="map-tile"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                if (e.target.nextSibling) e.target.nextSibling.style.display = 'block';
                              }}
                            />
                            <div className="house-icon">🏠</div>
                            <div className="map-fallback" style={{display: 'none'}}>
                              <div className="map-dot"></div>
                            </div>
                          </div>
                        </div>
                        <div className="property-image">
                          <div
                            className="property-photo clickable"
                            onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                            style={{cursor: 'pointer'}}
                          >
                            <PropertyThumbnail listingKey={property.listing_key}
                                src={propertyImages[property.listing_key] || property.first_photo_url || property.image_url || property.photo_url}
                                alt={`Property at ${property.address || property.street_address || 'listing'}`}
                                className="property-thumbnail"
                              />
                          </div>
                        </div>
                        <div className="property-details">
                          <div className="property-address">{formatPropertyAddress(property) || `Property ID: ${property.id}`}</div>
                          <div className="property-price">${property.current_price || property.price}</div>
                          <div className="property-specs">
                            {(property.bedrooms_total || property.bedrooms) && `${property.bedrooms_total || property.bedrooms} bed`}
                            {property.property_type && ` • ${property.property_type}`}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {assistantEnabled && message.currentPage > 0 && <button type="button" className="service-button" onClick={() => setMessages(prev => prev.map((m, i) => i === index ? { ...m, currentPage: m.currentPage - 1 } : m))}>Previous six homes</button>}
                  {message.pageError && <p role="alert">{message.pageError} {message.restartSearch && <button type="button" onClick={()=>fetchProperties(message.searchFilters)}>Restart search</button>}</p>}
                  {(message.hasMore || message.properties.length > ((message.currentPage || 0) + 1) * itemsPerPage) && (
                    <div style={{textAlign: 'center', marginTop: '15px'}}>
                      <button
                        className="service-button"
                        disabled={message.loadingMore}
                        onClick={() => handleShowMoreProperties(index)}
                        style={{background: '#007bff', color: 'white'}}
                      >
                        {message.loadingMore?'Loading homes…':`Show next ${itemsPerPage} homes`}
                      </button>
                    </div>
                  )}
                </div>
              ) : message.content === 'agent_contact_capture' ? (
                message.submitted ? (
                  <p>✓ Contact details submitted.</p>
                ) : (
                <div>
                  <p>Sure! Just share your contact details and the agent will reach out:</p>
                  <form className="chat-form" onSubmit={async (e) => {
                    e.preventDefault();
                    setName(leadName);
                    setPhoneNumber(leadPhone);
                    if (!isHoneypotSubmission(e.currentTarget)) {
                      localStorage.setItem('leadInfo', JSON.stringify({ name: leadName, email: leadEmail, phone: leadPhone }));
                      await sendAgentSMS(leadName, leadPhone);
                    }
                    markCaptureFormSubmitted('agent_contact_capture');
                    setMessages(prev => [...prev, { type: 'bot', content: `Got it, ${leadName}! The agent will contact you at ${leadPhone} shortly.` }]);
                    setLeadName(''); setLeadPhone(''); setLeadEmail('');
                  }}>
                    <HoneypotField />
                    <input type="text" placeholder="Your name" value={leadName} onChange={(e) => setLeadName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={leadPhone} onChange={(e) => setLeadPhone(e.target.value)} className="form-input" required />
                    <button type="submit" className="form-submit cta-button">Contact Me</button>
                  </form>
                </div>
                )
              ) : message.content === 'seller_lead_capture' ? (
                message.submitted ? (
                  <p>✓ Contact details submitted.</p>
                ) : (
                <div>
                  <p>To follow up on your property, I just need a few quick details:</p>
                  <form className="chat-form" onSubmit={handleSellerLeadCaptureSubmit}>
                    <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    <button type="submit" className="form-submit cta-button">Submit</button>
                  </form>
                </div>
                )
              ) : message.content === 'buyer_lead_capture' ? (
                message.submitted ? (
                  <p>✓ Contact details submitted.</p>
                ) : (
                <div>
                  <p>I'd love to help you find a home! Just need a few details:</p>
                  <form className="chat-form" onSubmit={handleBuyerLeadCaptureSubmit}>
                    <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    {!pendingBuyerParams?.city && !pendingBuyerParams?.zip && (
                      <input type="text" placeholder="City or zip code" value={zipCode} onChange={(e) => setZipCode(e.target.value)} className="form-input" required />
                    )}
                    {!pendingBuyerParams?.maxPrice && (
                      <input type="number" placeholder="Max price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="form-input" />
                    )}
                    <button type="submit" className="form-submit cta-button">Search Properties</button>
                  </form>
                </div>
                )
              ) : (
                message.content
              )}
            </div>
          ))}
          {(isThinking || isPropertySearching) && (
            <div className="message bot-message assistant-activity-message" role="status">
              <span className="assistant-message-author">{assistantName}</span>
              <div className="assistant-activity-row">
                <span className="assistant-typing-dots"><i></i><i></i><i></i></span>
                <span>{isPropertySearching ? 'Searching live listings and preparing your matches…' : 'Thinking through your request…'}</span>
              </div>
            </div>
          )}
          {showRegistration && (
            <div className="message bot-message">
              Please complete your registration:
              <form className="chat-form" onSubmit={handleRegistrationSubmit}>
                <input
                  type="text"
                  placeholder="Username"
                  value={regName}
                  onChange={(e) => setRegName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={regEmail}
                  onChange={(e) => setRegEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={regPassword}
                  onChange={(e) => setRegPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={regPhoneNumber}
                  onChange={(e) => setRegPhoneNumber(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={regFullName}
                  onChange={(e) => setRegFullName(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Register</button>
              </form>
            </div>
          )}
          {showLogin && !showForgotPassword && (
            <div className="message bot-message">
              Please sign in:
              <form className="chat-form" onSubmit={handleLoginSubmit}>
                <input
                  type="text"
                  placeholder="Username or Email"
                  value={loginUsername}
                  onChange={(e) => setLoginUsername(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Sign In</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => setShowForgotPassword(true)}
                >
                  Forgot Password?
                </button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowLogin(false); setShowRegistration(true); }}
                >
                  Don't have an account? Register
                </button>
              </form>
            </div>
          )}
          {showForgotPassword && (
            <div className="message bot-message">
              Enter your email to reset your password:
              <form className="chat-form" onSubmit={handlePasswordResetSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Send Reset Link</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowForgotPassword(false); setResetEmail(''); }}
                >
                  Back to Sign In
                </button>
              </form>
            </div>
          )}

        </div>
        {assistantEnabled && <>{!isFullPage && <div className="discovery-toolbar"><button disabled={discovery.busy} onClick={async()=>assistantResult(await discovery.showFavorites())}>Saved homes · {likedProperties.size}</button><button onClick={()=>discovery.setPreferencesOpen(true)}>Home preferences</button><button onClick={async()=>assistantResult(await discovery.run({command:'show_results'},[]))}>Search results</button></div>}<ComparisonTray homes={discovery.homes} onRemove={discovery.remove} onClear={discovery.clear} onCompare={async()=>assistantResult(await discovery.compare())} busy={discovery.busy} />{!isFullPage && <VoiceControls compact={isFullPage} voice={voice} onContinueTyping={() => {
          const input = ['#property-save-name','[role="dialog"] input:not([tabindex="-1"])','[aria-label="Ask about this map"]','#assistant-home-question','.chat-input'].map(selector => document.querySelector(selector)).find(element => element && !element.disabled && element.offsetParent !== null);
          if (input?.matches('.chat-input')) scrollMobileWorkspaceTo('chat');
          requestAnimationFrame(() => input?.focus({preventScroll:true}));
        }} />}</>}
        <ActiveSearchFilters filters={pendingSearchFilters || (chatSearchContextRef.current?.siteId === chatSiteId ? chatSearchContextRef.current.params : null)} searching={Boolean(pendingSearchFilters)} busy={isThinking || isPropertySearching} onRemove={chip=>processAssistantMessage(`Remove the ${chip.name.toLowerCase()} filter`)} />
        <ChatComposer
          user={user}
          openChat={assistantEnabled || openChat}
          hidePrompts={hidePrompts}
          showPrompts={showPrompts}
          onTogglePrompts={() => setShowPrompts(!showPrompts)}
          conversationFirst={isFullPage}
          introductory={isFullPage && !hasConversationStarted}
          voiceControls={isFullPage && assistantEnabled ? <VoiceControls compact={isFullPage} voice={voice} onContinueTyping={() => {
          const input = ['#property-save-name','[role="dialog"] input:not([tabindex="-1"])','[aria-label="Ask about this map"]','#assistant-home-question','.chat-input'].map(selector => document.querySelector(selector)).find(element => element && !element.disabled && element.offsetParent !== null);
          if (input?.matches('.chat-input')) scrollMobileWorkspaceTo('chat');
          requestAnimationFrame(() => input?.focus({preventScroll:true}));
        }} /> : null}
          tools={isFullPage && assistantEnabled ? <div className="discovery-toolbar"><button type="button" disabled={discovery.busy} onClick={async()=>assistantResult(await discovery.showFavorites())}>Saved homes · {likedProperties.size}</button><button type="button" onClick={()=>discovery.setPreferencesOpen(true)}>Home preferences</button>{hasPropertyWorkspace && <button type="button" onClick={async()=>assistantResult(await discovery.run({command:'show_results'},[]))}>Search results</button>}<button type="button" disabled={isThinking || isPropertySearching} onClick={()=>handlePromptSelect(`Contact ${SITE_CONFIG.AGENT.NAME}`)}>Contact {SITE_CONFIG.AGENT.NAME}</button></div> : null}
          prompts={isFullPage ? [
            {display: 'Help me find a home', value: 'Help me find a home'},
            {display: 'I’m thinking about selling', value: 'I am thinking about selling my home'},
            {display: 'I have a question', value: 'I have a real estate question. Can you help?'}
          ] : commonPrompts}
          onPromptSelect={handlePromptSelect}
          inputValue={inputValue}
          onInputChange={setInputValue}
          onKeyPress={handleKeyPress}
          onSend={handleSendMessage}
          isBusy={isThinking || isPropertySearching}
          onSignIn={() => {
            setShowRegistration(false);
            setShowForgotPassword(false);
            setShowLogin(true);
          }}
        />
          </section>
          {hasPropertyWorkspace && (
            <aside className={`assistant-results-panel ${assistantEnabled ? 'assistant-results-paged' : ''}`} ref={assistantResultsPanelRef} aria-label={`Matching properties ${resultsContext(latestPropertyMessage).results_start} through ${resultsContext(latestPropertyMessage).results_end}`}>
              <button type="button" className="assistant-mobile-back-to-chat" onClick={() => scrollMobileWorkspaceTo('chat')}>
                <span aria-hidden="true">←</span>
                Back to chat
              </button>
              <div className="assistant-results-header">
                <div>
                  <span className="assistant-results-eyebrow">{latestPropertyMessage.isFavorites ? 'Your saved homes' : 'Live search results'}</span>
                  <h2>Showing properties <em>{resultsContext(latestPropertyMessage).results_start}–{resultsContext(latestPropertyMessage).results_end}</em></h2>
                  <p>{resultsContext(latestPropertyMessage).results_has_more ? 'This is one page of your matches. Use “Show next 6 properties” to keep exploring.' : 'You’re on the last page of matching properties.'}</p>
                </div>
                <div className="assistant-results-actions">
                  <button type="button" onClick={() => handlePromptSelect('Refine these property results')}>Refine search</button>
                  <button type="button" className="assistant-results-alert" onClick={() => handlePromptSelect('Create a property alert for this search')}>Create alert</button>
                </div>
              </div>
              {renderPropertyPagination("top")}
              {assistantEnabled && latestPropertyMessage.pageError && <p role="alert">{latestPropertyMessage.pageError}</p>}
              <PropertyRailNavigation
                key={`navigation:${latestPropertyMessage.searchId}`}
                railRef={assistantPropertyRailRef}
                count={visibleWorkspaceProperties.length}
                page={latestPropertyMessage.currentPage || 0}
              />
              <div className="assistant-property-grid" data-results-search={latestPropertyMessage.searchId} data-results-page={latestPropertyMessage.currentPage || 0} ref={assistantPropertyRailRef} key={latestPropertyMessage.searchId} aria-label="Matching homes">
                {visibleWorkspaceProperties.map((property, propertyIndex) => {
                  const propertyKey = getPropertyKey(property, propertyIndex);
                  const propertyAddress = getPropertyAddress(property);
                  const propertyPhoto = propertyImages[property.listing_key] || property.first_photo_url || property.image_url || property.photo_url;
                  const rawPropertyLatitude = property.latitude ?? property.location?.latitude;
                  const rawPropertyLongitude = property.longitude ?? property.location?.longitude;
                  const propertyLatitude = Number(rawPropertyLatitude);
                  const propertyLongitude = Number(rawPropertyLongitude);
                  const hasPropertyCoords = rawPropertyLatitude != null && rawPropertyLatitude !== '' && rawPropertyLongitude != null && rawPropertyLongitude !== '' && Number.isFinite(propertyLatitude) && Number.isFinite(propertyLongitude);
                  const propertyMapTile = hasPropertyCoords ? getTileCoords(propertyLatitude, propertyLongitude, 15) : null;
                  const bedrooms = property.bedrooms_total || property.bedrooms;
                  const bathrooms = property.bathrooms_total_integer || property.bathrooms_total || property.bathrooms;
                  const squareFeet = property.living_area || property.building_area_total || property.square_feet;
                  const isSaved = likedProperties.has(propertyKey);
                  return (
                    <article key={propertyKey} data-result-card data-property-index={propertyIndex} className={`assistant-property-card ${hasPropertyCoords ? 'assistant-property-card-has-map' : ''}`}>
                      {assistantEnabled && <span className="assistant-property-number">{propertyIndex + 1}</span>}
                      <button
                        type="button"
                        className="assistant-property-media"
                        onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                        aria-label={`View details for ${propertyAddress}`}
                      >
                        <PropertyThumbnail listingKey={property.listing_key} src={propertyPhoto} alt={`Property at ${propertyAddress}`} />
                        <span className="assistant-property-live">Live listing</span>
                      </button>
                      {hasPropertyCoords && (
                        <button
                          type="button"
                          className="assistant-property-map-thumbnail"
                          onClick={() => setExpandedMap({ lat: propertyLatitude, lon: propertyLongitude, address: propertyAddress })}
                          aria-label={`Open interactive map for ${propertyAddress}`}
                          title="Open interactive map"
                        >
                          <img
                            src={`https://tile.openstreetmap.org/15/${propertyMapTile.x}/${propertyMapTile.y}.png`}
                            alt=""
                            aria-hidden="true"
                            loading="lazy"
                          />
                          <span aria-hidden="true"><i /></span>
                          <small>Map</small>
                        </button>
                      )}
                      <button
                        type="button"
                        className={`assistant-property-save ${isSaved ? 'saved' : ''}`}
                        onClick={() => toggleWorkspaceFavorite(property, propertyIndex)}
                        aria-label={isSaved ? `Remove ${propertyAddress} from saved properties` : `Save ${propertyAddress}`}
                        aria-pressed={isSaved}
                      >
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" /></svg>
                        <span>{isSaved ? 'Saved' : 'Save'}</span>
                      </button>
                      <div className="assistant-property-content">
                        {assistantEnabled && <button className="discovery-compare-toggle" aria-pressed={discovery.homes.some(h=>homeKey(h)===homeKey(property))} onClick={()=>{if(discovery.homes.some(h=>homeKey(h)===homeKey(property)))discovery.remove(homeKey(property));else assistantResult(discovery.add([property]));}}>{discovery.homes.some(h=>homeKey(h)===homeKey(property))?'Selected for comparison':'Add to comparison'}</button>}
                        <div className="assistant-property-price-row">
                          <strong>{formatPropertyPrice(property.current_price || property.price)}</strong>
                          {property.property_type && <span>{property.property_type}</span>}
                        </div>
                        <p>{propertyAddress}</p>
                        <div className="assistant-property-specs">
                          {bedrooms && <span><strong>{bedrooms}</strong> beds</span>}
                          {bathrooms && <span><strong>{bathrooms}</strong> baths</span>}
                          {squareFeet && <span><strong>{Number.isFinite(Number(squareFeet)) ? Number(squareFeet).toLocaleString() : squareFeet}</strong> sq ft</span>}
                        </div>
                        <div className="assistant-property-insight">
                          <span></span>
                          A current match from the live local feed.
                        </div>
                        <div className="assistant-property-actions">
                          <button type="button" onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}>View residence</button>
                          <button type="button" onClick={async () => assistantEnabled ? assistantResult(await executeAssistantUi({command:'open_showing',number:propertyIndex+1,revision:getAssistantContext().revision})) : handlePromptSelect(`I would like to schedule a showing for ${propertyAddress}`)}>{assistantEnabled?'Request showing':'Schedule showing'}</button>
                        </div>
                      </div>
                    </article>
                  );
                })}
              {!assistantEnabled && remainingWorkspaceProperties > 0 && (
                <div className="assistant-results-load-more" aria-label="More matching homes" aria-busy={Boolean(latestPropertyMessage.loadingMore)}>
                  <div className="assistant-results-progress-copy">
                    <span>{visibleWorkspaceProperties.length} homes shown</span>
                    <span>{latestPropertyMessage.hasMore?'More homes available':`${remainingWorkspaceProperties} remaining`}</span>
                  </div>

                  {latestPropertyMessage.pageError && <p className="assistant-results-page-error" role="alert">{latestPropertyMessage.pageError}</p>}
                  <button type="button" className="assistant-results-more" disabled={latestPropertyMessage.loadingMore} onClick={latestPropertyMessage.restartSearch ? () => fetchProperties(latestPropertyMessage.searchFilters) : handleWorkspaceShowMore}>
                    <span className="assistant-results-more-copy">
                      <small>Continue browsing</small>
                      <strong>{latestPropertyMessage.loadingMore ? 'Loading homes…' : latestPropertyMessage.restartSearch ? 'Restart search' : latestPropertyMessage.pageError ? 'Try again' : `See ${nextWorkspacePropertyCount} more properties`}</strong>
                    </span>
                    <span className="assistant-results-more-arrow" aria-hidden="true">→</span>
                  </button>
                </div>
              )}
              </div>
              {renderPropertyPagination("bottom")}
              <button type="button" className="assistant-results-chat-cta" onClick={() => scrollMobileWorkspaceTo('chat')}>
                <span>Ask about these properties</span>
                <small>Return to your conversation</small>
              </button>
            </aside>
          )}
        </div>
      </div>
      {hasPropertyWorkspace && window.location.pathname === '/chat' && latestPropertyMessage.searchId != null && (
        <PropertySwipeHint
          key={`${latestPropertyMessageIndex}:${latestPropertyMessage.searchId}`}
          workspaceRef={assistantWorkspaceRef}
          resultsRef={assistantResultsPanelRef}
          paused={isPropertySearching || Boolean(propertyDetail) || Boolean(expandedMap)}
        />
      )}
      {expandedMap && (
        <div data-assistant-surface="map" className="expanded-map-modal assistant-map-overlay" onClick={() => setExpandedMap(null)}>
          <div ref={expandedMapDialogRef} tabIndex={-1} role="dialog" aria-modal="true" aria-label="Property results map" className="expanded-map" onClick={(e) => e.stopPropagation()}>
            <button className="close-expanded-map" aria-label="Close map" onClick={() => setExpandedMap(null)}>
              ×
            </button>
            <div className="assistant-map-instructions"><strong>{expandedMap.points ? "Homes on this page" : "Property map"}</strong><span>Say “zoom in”, “zoom out”, or “go back”.</span><button type="button" onClick={()=>setExpandedMap(null)}>{propertyDetail ? "Back to property details" : "Back to results"}</button></div><div ref={mapRef} className="leaflet-map"></div>
          </div>
        </div>
      )}
      {assistantEnabled && discovery.preferencesOpen && <PreferencesPanel profile={discovery.profile} onSave={discovery.save} onClose={()=>discovery.setPreferencesOpen(false)} />}
      {assistantEnabled && discovery.comparisonOpen && <ComparisonPanel homes={discovery.comparison} onClose={()=>discovery.setComparisonOpen(false)} onAsk={processAssistantMessage} busy={isThinking} answer={discovery.answer} />}
      {assistantEnabled && <MapPlaceLayers compact={isGlobeMap && !expandedMap} compactOpen={activeMapTool === 'places'} onCompactOpenChange={setPlacesOpen} map={expandedMap ? expandedMapInstance : isGlobeMap && globeMap && mapView && !propertyDetail ? globeMapInstance : null} controlRef={mapPlacesRef} onState={mapPlacesState} onMessage={processAssistantMessage} />}
        {propertyDetailOverlay}
      {assistantEnabled && <SellerInquiryReview controlRef={sellerReviewRef} conversationKey={`${chatSiteId}:${chatGenerationRef.current}`} onState={onSellerState} agentName={SITE_CONFIG.AGENT.NAME} onAsk={processAssistantMessage} assistantBusy={isThinking || isPropertySearching} onResult={assistantResult} onSubmit={async draft=>{
        const generation=chatGenerationRef.current;
        const outcome=await submitSellerInquiry(draft,draft.email,draft.name,draft.phone);
        if(outcome.ok && generation===chatGenerationRef.current){setName(draft.name);setEmail(draft.email);setPhoneNumber(draft.phone);setChatLeadSubmitted(true);try{localStorage.setItem('leadInfo',JSON.stringify({name:draft.name,email:draft.email,phone:draft.phone}));}catch{}}
        return outcome;
      }}/>}
    </div>
  );
};
export default FleetChatAssistant;
